unit View.Produtos.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls, UUtils,
  System.StrUtils, WEBLib.Grids, WEBLib.Lists, UHelperServer, Grid.Plugins,
  UConstantes, WEBLib.WebCtrls, UFrameAssociacaoProdutos, Vcl.Forms;

type
  TFViewProdutosEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_nome: TLabel;
    edaliado_nome: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbnome_abreviado: TLabel;
    ednome_abreviado: TDBEdit;
    lbcodigo_barras: TLabel;
    edcodigo_barras: TDBEdit;
    lbcodigo_fabrica: TLabel;
    edcodigo_fabrica: TDBEdit;
    lbestoque: TLabel;
    edestoque: TDBEdit;
    lbestoque_retido: TLabel;
    edestoque_retido: TDBEdit;
    lbestoque_maximo: TLabel;
    edestoque_maximo: TDBEdit;
    lbestoque_minimo: TLabel;
    edestoque_minimo: TDBEdit;
    lbpreco_custo: TLabel;
    edpreco_custo: TDBEdit;
    lbpreco_venda: TLabel;
    edpreco_venda: TDBEdit;
    lbpreco_promocional: TLabel;
    edpreco_promocional: TDBEdit;
    lbmargem_lucro: TLabel;
    edmargem_lucro: TDBEdit;
    lbpreco_padrao: TLabel;
    edpreco_padrao: TDBEdit;
    lbdesconto_maximo: TLabel;
    eddesconto_maximo: TDBEdit;
    lbvalor_desconto_maximo: TLabel;
    edvalor_desconto_maximo: TDBEdit;
    lbcomissao: TLabel;
    edcomissao: TDBEdit;
    lbstatus: TLabel;
    edstatus: TDBEdit;
    lbunidade_nome: TLabel;
    edunidade_nome: TDBEdit;
    lbsubgrupo_nome: TLabel;
    edsubgrupo_nome: TDBEdit;
    lbdesativado: TLabel;
    lbgerencial: TLabel;
    lbcomposto: TLabel;
    lbgrade: TLabel;
    lbcadastro: TLabel;
    edcadastro: TDBEdit;
    lbpeso_bruto: TLabel;
    edpeso_bruto: TDBEdit;
    lbpeso_liquido: TLabel;
    edpeso_liquido: TDBEdit;
    lbproduto_movimenta_estoque: TLabel;
    edproduto_movimenta_estoque: TDBEdit;
    lbproduto_movimenta_estoque_quantidade: TLabel;
    edproduto_movimenta_estoque_quantidade: TDBEdit;
    lbaplicacao: TLabel;
    edaplicacao: TDBEdit;
    lbobservacoes: TLabel;
    edobservacoes: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientProdutosGet: TXDataWebClient;
    ProdutosDataset: TXDataWebDataSet;
    ProdutosDatasetid: TIntegerField;
    ProdutosDatasetaliado_id: TIntegerField;
    ProdutosDatasetdata_base_id: TIntegerField;
    ProdutosDatasetnome: TStringField;
    ProdutosDatasetnome_abreviado: TStringField;
    ProdutosDatasetcodigo_barras: TStringField;
    ProdutosDatasetcodigo_fabrica: TStringField;
    ProdutosDatasetestoque: TFloatField;
    ProdutosDatasetestoque_retido: TFloatField;
    ProdutosDatasetestoque_maximo: TFloatField;
    ProdutosDatasetestoque_minimo: TFloatField;
    ProdutosDatasetpreco_custo: TFloatField;
    ProdutosDatasetpreco_venda: TFloatField;
    ProdutosDatasetpreco_promocional: TFloatField;
    ProdutosDatasetmargem_lucro: TFloatField;
    ProdutosDatasetpreco_padrao: TIntegerField;
    ProdutosDatasetdesconto_maximo: TFloatField;
    ProdutosDatasetvalor_desconto_maximo: TFloatField;
    ProdutosDatasetcomissao: TFloatField;
    ProdutosDatasetstatus: TIntegerField;
    ProdutosDatasetunidade_id: TIntegerField;
    ProdutosDatasetsubgrupo_id: TIntegerField;
    ProdutosDatasetdesativado: TBooleanField;
    ProdutosDatasetgerencial: TBooleanField;
    ProdutosDatasetcomposto: TBooleanField;
    ProdutosDatasetgrade: TBooleanField;
    ProdutosDatasetcadastro: TDateTimeField;
    ProdutosDatasetpeso_bruto: TFloatField;
    ProdutosDatasetpeso_liquido: TFloatField;
    ProdutosDatasetproduto_movimenta_estoque: TIntegerField;
    ProdutosDatasetproduto_movimenta_estoque_quantidade: TFloatField;
    ProdutosDatasetaplicacao: TStringField;
    ProdutosDatasetobservacoes: TStringField;
    ProdutosDatasettributacao: TStringField;
    ProdutosDatasetcodigo_interno: TIntegerField;
    ProdutosDatasetexcluido: TBooleanField;
    ProdutosDatasetinclusao: TDateTimeField;
    ProdutosDatasetalteracao: TDateTimeField;
    ProdutosDatasetexclusao: TDateTimeField;
    lbgrupo_nome: TLabel;
    edgrupo_nome: TDBEdit;
    ProdutosDatasetunidadesigla: TXDataWebDatasetField;
    ProdutosDatasetsubgruponome: TXDataWebDatasetField;
    ProdutosDatasetsubgrupogruponome: TXDataWebDatasetField;
    cbxdesativado: TDBCheckBox;
    cbxgerencial: TDBCheckBox;
    cbxcomposto: TDBCheckBox;
    cbxgrade: TDBCheckBox;
    cbxexcluido: TDBCheckBox;
    ProdutosDatasetaliadoNome_Fantasia: TXDataWebDatasetField;
    pnlDadosProdutos: TPanel;
    btnDadosTab: TButton;
    btnAssociacaoTab: TButton;
    ProdutosDatasetassociacaofsprodimagem: TXDataWebDatasetField;
    ProdutosDatasetassociacaofsprodid: TXDataWebDatasetField;
    ProdutosDatasetassociacaofsprodnome: TXDataWebDatasetField;
    ProdutosDatasetassociacaofsprodcodigo_barras: TXDataWebDatasetField;
    ProdutosDatasetassociacaostatus: TXDataWebDatasetField;
    ProdutosDatasetassociacaoimagem_aprovacao: TXDataWebDatasetField;
    lbncm_ncm: TLabel;
    ed_ncm_ncm: TDBEdit;
    ProdutosDatasetncmncm: TStringField;
    pnlProdutoAssociado: TPanel;
    lblCodigoProdutoAssociado: TLabel;
    edtCodigoProdutoAssociado: TEdit;
    edtNomeProdutoAssociado: TEdit;
    lblNomeProdutoAssociado: TLabel;
    lblCodBarrasProdutoAssociado: TLabel;
    edtCodBarrasProdutoAssociado: TEdit;
    edtStatusProdutoAssociado: TEdit;
    lblStatusProdutoAssociado: TLabel;
    imgProduto: TImageControl;
    lbpreco_consignado: TLabel;
    edpreco_consignado: TDBEdit;
    ProdutosDatasetpreco_consignado: TFloatField;
    procedure btCancelClick(Sender: TObject);
    procedure XDataClientProdutosGetLoad(Response: TXDataClientResponse);
    procedure ProdutosDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure ProdutosDatasetpreco_padraoGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure ProdutosDatasetstatusGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure ProdutosDatasetaliadoNome_FantasiaGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure ProdutosDatasetAfterOpen(DataSet: TDataSet);
    procedure frmFrameAssociacaoProdutosXDataWebClientAssociacaoLoad(
      Response: TXDataClientResponse);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    FQueryExpand : string;

    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
    procedure RecarregarDados;
    procedure SetDadosProdutoAssociado(pStatus, pId, pNome, pCodigoBarras,
      pImagem, pImagemAprovacao : string);
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewProdutosEdit: TFViewProdutosEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewProdutosEdit }


class function TFViewProdutosEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewProdutosEdit.frmFrameAssociacaoProdutosXDataWebClientAssociacaoLoad(
  Response: TXDataClientResponse);
begin
  if Response.RequestId <> 'null' then
    TUtils.CloseModal(Response.RequestId);

  RecarregarDados;
end;

procedure TFViewProdutosEdit.InsertEntity;
begin
  ProdutosDataset.Close;
  ProdutosDataset.SetJsonData('{}');
  ProdutosDataset.Open;
  ProdutosDataset.Insert;
end;

class function TFViewProdutosEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewProdutosEdit(AForm).FInserting := AInserting;
    TFViewProdutosEdit(AForm).FId := AId;
    TFViewProdutosEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewProdutosEdit(AForm).InsertEntity
    else
      TFViewProdutosEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewProdutosEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewProdutosEdit.LoadEntity;
begin
  FQueryExpand := TCrudUtils.GetEntityGetQueryString(
    ProdutosDataset.Connection.Model.DefaultSchema.FindEntityType(
      ProdutosDataset.EntitySetName
    )
  );
  FQueryExpand := FQueryExpand + ', subgrupo/grupo, associacao/fsprod';

  XDataClientProdutosGet.Get(ProdutosDataset.EntitySetName, FQueryExpand, FId);
end;

procedure TFViewProdutosEdit.XDataClientProdutosGetLoad(Response: TXDataClientResponse);
begin
  ProdutosDataset.Close;
  ProdutosDataset.SetJsonData(Response.Result);
  ProdutosDataset.Open;
end;

procedure TFViewProdutosEdit.ProdutosDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewProdutosEdit.ProdutosDatasetAfterOpen(DataSet: TDataSet);
begin
  SetDadosProdutoAssociado(ProdutosDataset.FieldByName('associacao.status').AsString,
    ProdutosDataset.FieldByName('associacao.fsprod.id').AsString, ProdutosDataset.FieldByName('associacao.fsprod.nome').AsString,
      ProdutosDataset.FieldByName('associacao.fsprod.codigo_barras').AsString, ProdutosDataset.FieldByName('associacao.fsprod.imagem').AsString,
        ProdutosDataset.FieldByName('associacao.imagem_aprovacao').AsString);

  TUtils.OcultarDivLoading;
end;

procedure TFViewProdutosEdit.ProdutosDatasetaliadoNome_FantasiaGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := Sender.AsString.ToUpper;
end;

procedure TFViewProdutosEdit.ProdutosDatasetpreco_padraoGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.GetPrecoPadraoProduto(Sender.AsInteger).ToUpper;
end;

procedure TFViewProdutosEdit.ProdutosDatasetstatusGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.GetNomeStatusProduto(Sender.AsInteger);
end;

procedure TFViewProdutosEdit.RecarregarDados;
begin
  XDataClientProdutosGet.Get(ProdutosDataset.EntitySetName, FQueryExpand, FId);
end;

procedure TFViewProdutosEdit.SetDadosProdutoAssociado(pStatus, pId, pNome,
  pCodigoBarras, pImagem, pImagemAprovacao: string);
var
  lStatus,
  lCodigo,
  lNome,
  lCodigoBarras,
  lImagem : string;
begin
  lStatus := THelperServer.GetStatusAssociacao(pStatus).ToUpper;
  edtStatusProdutoAssociado.Text := lStatus;

  case IndexStr(lStatus, ['SEM PRODUTO ASSOCIADO', 'ASSOCIADO', 'AGUARDANDO VALIDAÇÃO FOTO',
    'AGUARDANDO VALIDAÇÃO CADASTRO']) of
    0:
    begin
      lCodigo := '';
      lNome := '';
      lCodigoBarras := '';
      lImagem := '';
    end;
    1, 2:
    begin
      lCodigo := pId;
      lNome := pNome;
      lCodigoBarras := pCodigoBarras;

      if lStatus = 'ASSOCIADO' then
        lImagem := pImagem
      else
        lImagem := pImagemAprovacao;
    end;
    3:
    begin
      lCodigo := '';
      lNome := ednome.Text;
      lCodigoBarras := edcodigo_barras.Text;
      lImagem := pImagemAprovacao;
    end;
  end;

  if THelperServer.PossuiImagem(lImagem) then
    imgProduto.url := lImagem
  else
    imgProduto.url := 'assets/img/produto_sem_imagem.webp';

  edtCodigoProdutoAssociado.Text := lCodigo;
  edtNomeProdutoAssociado.Text := lNome;
  edtCodBarrasProdutoAssociado.Text := lCodigoBarras;
end;

procedure TFViewProdutosEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewProdutosEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.produtos.form.lbid');
  lbaliado_nome := TLabel.Create('view.produtos.form.lbaliado_nome');
  lbnome := TLabel.Create('view.produtos.form.lbnome');
  lbnome_abreviado := TLabel.Create('view.produtos.form.lbnome_abreviado');
  lbcodigo_barras := TLabel.Create('view.produtos.form.lbcodigo_barras');
  lbcodigo_fabrica := TLabel.Create('view.produtos.form.lbcodigo_fabrica');
  lbestoque := TLabel.Create('view.produtos.form.lbestoque');
  lbestoque_retido := TLabel.Create('view.produtos.form.lbestoque_retido');
  lbestoque_maximo := TLabel.Create('view.produtos.form.lbestoque_maximo');
  lbestoque_minimo := TLabel.Create('view.produtos.form.lbestoque_minimo');
  lbpreco_custo := TLabel.Create('view.produtos.form.lbpreco_custo');
  lbpreco_venda := TLabel.Create('view.produtos.form.lbpreco_venda');
  lbpreco_promocional := TLabel.Create('view.produtos.form.lbpreco_promocional');
  lbmargem_lucro := TLabel.Create('view.produtos.form.lbmargem_lucro');
  lbpreco_padrao := TLabel.Create('view.produtos.form.lbpreco_padrao');
  lbdesconto_maximo := TLabel.Create('view.produtos.form.lbdesconto_maximo');
  lbvalor_desconto_maximo := TLabel.Create('view.produtos.form.lbvalor_desconto_maximo');
  lbcomissao := TLabel.Create('view.produtos.form.lbcomissao');
  lbstatus := TLabel.Create('view.produtos.form.lbstatus');
  lbunidade_nome := TLabel.Create('view.produtos.form.lbunidade_nome');
  lbsubgrupo_nome := TLabel.Create('view.produtos.form.lbsubgrupo_nome');
  lbdesativado := TLabel.Create('view.produtos.form.lbdesativado');
  lbgerencial := TLabel.Create('view.produtos.form.lbgerencial');
  lbcomposto := TLabel.Create('view.produtos.form.lbcomposto');
  lbgrade := TLabel.Create('view.produtos.form.lbgrade');
  lbcadastro := TLabel.Create('view.produtos.form.lbcadastro');
  lbpeso_bruto := TLabel.Create('view.produtos.form.lbpeso_bruto');
  lbpeso_liquido := TLabel.Create('view.produtos.form.lbpeso_liquido');
  lbproduto_movimenta_estoque := TLabel.Create('view.produtos.form.lbproduto_movimenta_estoque');
  lbproduto_movimenta_estoque_quantidade := TLabel.Create('view.produtos.form.lbproduto_movimenta_estoque_quantidade');
  lbaplicacao := TLabel.Create('view.produtos.form.lbaplicacao');
  lbobservacoes := TLabel.Create('view.produtos.form.lbobservacoes');
  lbcodigo_interno := TLabel.Create('view.produtos.form.lbcodigo_interno');
  lbexcluido := TLabel.Create('view.produtos.form.lbexcluido');
  lbinclusao := TLabel.Create('view.produtos.form.lbinclusao');
  lbalteracao := TLabel.Create('view.produtos.form.lbalteracao');
  lbexclusao := TLabel.Create('view.produtos.form.lbexclusao');
  lbgrupo_nome := TLabel.Create('view.produtos.form.lbgrupo_nome');
  lbncm_ncm := TLabel.Create('view.produtos.form.lbncm_ncm');
  lblCodigoProdutoAssociado := TLabel.Create('lblCodigoProdutoAssociado');
  lblNomeProdutoAssociado := TLabel.Create('lblNomeProdutoAssociado');
  lblCodBarrasProdutoAssociado := TLabel.Create('lblCodBarrasProdutoAssociado');
  lblStatusProdutoAssociado := TLabel.Create('lblStatusProdutoAssociado');
  imgProduto := TImageControl.Create('imgProduto');
  lbpreco_consignado := TLabel.Create('view.produtos.form.lbpreco_consignado');
  btCancel := TButton.Create('view.produtos.form.btBack');
  edid := TDBEdit.Create('view.produtos.form.edid');
  edaliado_nome := TDBEdit.Create('view.produtos.form.edaliado_nome');
  ednome := TDBEdit.Create('view.produtos.form.ednome');
  ednome_abreviado := TDBEdit.Create('view.produtos.form.ednome_abreviado');
  edcodigo_barras := TDBEdit.Create('view.produtos.form.edcodigo_barras');
  edcodigo_fabrica := TDBEdit.Create('view.produtos.form.edcodigo_fabrica');
  edestoque := TDBEdit.Create('view.produtos.form.edestoque');
  edestoque_retido := TDBEdit.Create('view.produtos.form.edestoque_retido');
  edestoque_maximo := TDBEdit.Create('view.produtos.form.edestoque_maximo');
  edestoque_minimo := TDBEdit.Create('view.produtos.form.edestoque_minimo');
  edpreco_custo := TDBEdit.Create('view.produtos.form.edpreco_custo');
  edpreco_venda := TDBEdit.Create('view.produtos.form.edpreco_venda');
  edpreco_promocional := TDBEdit.Create('view.produtos.form.edpreco_promocional');
  edmargem_lucro := TDBEdit.Create('view.produtos.form.edmargem_lucro');
  edpreco_padrao := TDBEdit.Create('view.produtos.form.edpreco_padrao');
  eddesconto_maximo := TDBEdit.Create('view.produtos.form.eddesconto_maximo');
  edvalor_desconto_maximo := TDBEdit.Create('view.produtos.form.edvalor_desconto_maximo');
  edcomissao := TDBEdit.Create('view.produtos.form.edcomissao');
  edstatus := TDBEdit.Create('view.produtos.form.edstatus');
  edunidade_nome := TDBEdit.Create('view.produtos.form.edunidade_nome');
  edsubgrupo_nome := TDBEdit.Create('view.produtos.form.edsubgrupo_nome');
  edcadastro := TDBEdit.Create('view.produtos.form.edcadastro');
  edpeso_bruto := TDBEdit.Create('view.produtos.form.edpeso_bruto');
  edpeso_liquido := TDBEdit.Create('view.produtos.form.edpeso_liquido');
  edproduto_movimenta_estoque := TDBEdit.Create('view.produtos.form.edproduto_movimenta_estoque');
  edproduto_movimenta_estoque_quantidade := TDBEdit.Create('view.produtos.form.edproduto_movimenta_estoque_quantidade');
  edaplicacao := TDBEdit.Create('view.produtos.form.edaplicacao');
  edobservacoes := TDBEdit.Create('view.produtos.form.edobservacoes');
  edcodigo_interno := TDBEdit.Create('view.produtos.form.edcodigo_interno');
  edinclusao := TDBEdit.Create('view.produtos.form.edinclusao');
  edalteracao := TDBEdit.Create('view.produtos.form.edalteracao');
  edexclusao := TDBEdit.Create('view.produtos.form.edexclusao');
  edgrupo_nome := TDBEdit.Create('view.produtos.form.edgrupo_nome');
  cbxdesativado := TDBCheckBox.Create('view.produtos.form.cbxdesativado');
  cbxgerencial := TDBCheckBox.Create('view.produtos.form.cbxgerencial');
  cbxcomposto := TDBCheckBox.Create('view.produtos.form.cbxcomposto');
  cbxgrade := TDBCheckBox.Create('view.produtos.form.cbxgrade');
  cbxexcluido := TDBCheckBox.Create('view.produtos.form.cbxexcluido');
  pnlDadosProdutos := TPanel.Create(Self);
  btnDadosTab := TButton.Create('line-dados-tab');
  btnAssociacaoTab := TButton.Create('line-associacao-tab');
  ed_ncm_ncm := TDBEdit.Create('view.produtos.form.edncm_ncm');
  pnlProdutoAssociado := TPanel.Create(Self);
  edtCodigoProdutoAssociado := TEdit.Create('edtCodigoProdutoAssociado');
  edtNomeProdutoAssociado := TEdit.Create('edtNomeProdutoAssociado');
  edtCodBarrasProdutoAssociado := TEdit.Create('edtCodBarrasProdutoAssociado');
  edtStatusProdutoAssociado := TEdit.Create('edtStatusProdutoAssociado');
  edpreco_consignado := TDBEdit.Create('view.produtos.form.edpreco_consignado');
  DataSource := TDataSource.Create(Self);
  ProdutosDataset := TXDataWebDataSet.Create(Self);
  ProdutosDatasetid := TIntegerField.Create(Self);
  ProdutosDatasetaliado_id := TIntegerField.Create(Self);
  ProdutosDatasetdata_base_id := TIntegerField.Create(Self);
  ProdutosDatasetnome := TStringField.Create(Self);
  ProdutosDatasetnome_abreviado := TStringField.Create(Self);
  ProdutosDatasetcodigo_barras := TStringField.Create(Self);
  ProdutosDatasetcodigo_fabrica := TStringField.Create(Self);
  ProdutosDatasetestoque := TFloatField.Create(Self);
  ProdutosDatasetestoque_retido := TFloatField.Create(Self);
  ProdutosDatasetestoque_maximo := TFloatField.Create(Self);
  ProdutosDatasetestoque_minimo := TFloatField.Create(Self);
  ProdutosDatasetpreco_custo := TFloatField.Create(Self);
  ProdutosDatasetpreco_venda := TFloatField.Create(Self);
  ProdutosDatasetpreco_promocional := TFloatField.Create(Self);
  ProdutosDatasetmargem_lucro := TFloatField.Create(Self);
  ProdutosDatasetpreco_padrao := TIntegerField.Create(Self);
  ProdutosDatasetdesconto_maximo := TFloatField.Create(Self);
  ProdutosDatasetvalor_desconto_maximo := TFloatField.Create(Self);
  ProdutosDatasetcomissao := TFloatField.Create(Self);
  ProdutosDatasetstatus := TIntegerField.Create(Self);
  ProdutosDatasetunidade_id := TIntegerField.Create(Self);
  ProdutosDatasetsubgrupo_id := TIntegerField.Create(Self);
  ProdutosDatasetdesativado := TBooleanField.Create(Self);
  ProdutosDatasetgerencial := TBooleanField.Create(Self);
  ProdutosDatasetcomposto := TBooleanField.Create(Self);
  ProdutosDatasetgrade := TBooleanField.Create(Self);
  ProdutosDatasetcadastro := TDateTimeField.Create(Self);
  ProdutosDatasetpeso_bruto := TFloatField.Create(Self);
  ProdutosDatasetpeso_liquido := TFloatField.Create(Self);
  ProdutosDatasetproduto_movimenta_estoque := TIntegerField.Create(Self);
  ProdutosDatasetproduto_movimenta_estoque_quantidade := TFloatField.Create(Self);
  ProdutosDatasetaplicacao := TStringField.Create(Self);
  ProdutosDatasetobservacoes := TStringField.Create(Self);
  ProdutosDatasettributacao := TStringField.Create(Self);
  ProdutosDatasetcodigo_interno := TIntegerField.Create(Self);
  ProdutosDatasetexcluido := TBooleanField.Create(Self);
  ProdutosDatasetinclusao := TDateTimeField.Create(Self);
  ProdutosDatasetalteracao := TDateTimeField.Create(Self);
  ProdutosDatasetexclusao := TDateTimeField.Create(Self);
  ProdutosDatasetunidadesigla := TXDataWebDatasetField.Create(Self);
  ProdutosDatasetsubgruponome := TXDataWebDatasetField.Create(Self);
  ProdutosDatasetsubgrupogruponome := TXDataWebDatasetField.Create(Self);
  ProdutosDatasetaliadoNome_Fantasia := TXDataWebDatasetField.Create(Self);
  ProdutosDatasetassociacaofsprodimagem := TXDataWebDatasetField.Create(Self);
  ProdutosDatasetassociacaofsprodid := TXDataWebDatasetField.Create(Self);
  ProdutosDatasetassociacaofsprodnome := TXDataWebDatasetField.Create(Self);
  ProdutosDatasetassociacaofsprodcodigo_barras := TXDataWebDatasetField.Create(Self);
  ProdutosDatasetassociacaostatus := TXDataWebDatasetField.Create(Self);
  ProdutosDatasetassociacaoimagem_aprovacao := TXDataWebDatasetField.Create(Self);
  ProdutosDatasetncmncm := TStringField.Create(Self);
  ProdutosDatasetpreco_consignado := TFloatField.Create(Self);
  XDataClientProdutosGet := TXDataWebClient.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbaliado_nome.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  lbnome_abreviado.BeforeLoadDFMValues;
  lbcodigo_barras.BeforeLoadDFMValues;
  lbcodigo_fabrica.BeforeLoadDFMValues;
  lbestoque.BeforeLoadDFMValues;
  lbestoque_retido.BeforeLoadDFMValues;
  lbestoque_maximo.BeforeLoadDFMValues;
  lbestoque_minimo.BeforeLoadDFMValues;
  lbpreco_custo.BeforeLoadDFMValues;
  lbpreco_venda.BeforeLoadDFMValues;
  lbpreco_promocional.BeforeLoadDFMValues;
  lbmargem_lucro.BeforeLoadDFMValues;
  lbpreco_padrao.BeforeLoadDFMValues;
  lbdesconto_maximo.BeforeLoadDFMValues;
  lbvalor_desconto_maximo.BeforeLoadDFMValues;
  lbcomissao.BeforeLoadDFMValues;
  lbstatus.BeforeLoadDFMValues;
  lbunidade_nome.BeforeLoadDFMValues;
  lbsubgrupo_nome.BeforeLoadDFMValues;
  lbdesativado.BeforeLoadDFMValues;
  lbgerencial.BeforeLoadDFMValues;
  lbcomposto.BeforeLoadDFMValues;
  lbgrade.BeforeLoadDFMValues;
  lbcadastro.BeforeLoadDFMValues;
  lbpeso_bruto.BeforeLoadDFMValues;
  lbpeso_liquido.BeforeLoadDFMValues;
  lbproduto_movimenta_estoque.BeforeLoadDFMValues;
  lbproduto_movimenta_estoque_quantidade.BeforeLoadDFMValues;
  lbaplicacao.BeforeLoadDFMValues;
  lbobservacoes.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  lbgrupo_nome.BeforeLoadDFMValues;
  lbncm_ncm.BeforeLoadDFMValues;
  lblCodigoProdutoAssociado.BeforeLoadDFMValues;
  lblNomeProdutoAssociado.BeforeLoadDFMValues;
  lblCodBarrasProdutoAssociado.BeforeLoadDFMValues;
  lblStatusProdutoAssociado.BeforeLoadDFMValues;
  imgProduto.BeforeLoadDFMValues;
  lbpreco_consignado.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  edaliado_nome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  ednome_abreviado.BeforeLoadDFMValues;
  edcodigo_barras.BeforeLoadDFMValues;
  edcodigo_fabrica.BeforeLoadDFMValues;
  edestoque.BeforeLoadDFMValues;
  edestoque_retido.BeforeLoadDFMValues;
  edestoque_maximo.BeforeLoadDFMValues;
  edestoque_minimo.BeforeLoadDFMValues;
  edpreco_custo.BeforeLoadDFMValues;
  edpreco_venda.BeforeLoadDFMValues;
  edpreco_promocional.BeforeLoadDFMValues;
  edmargem_lucro.BeforeLoadDFMValues;
  edpreco_padrao.BeforeLoadDFMValues;
  eddesconto_maximo.BeforeLoadDFMValues;
  edvalor_desconto_maximo.BeforeLoadDFMValues;
  edcomissao.BeforeLoadDFMValues;
  edstatus.BeforeLoadDFMValues;
  edunidade_nome.BeforeLoadDFMValues;
  edsubgrupo_nome.BeforeLoadDFMValues;
  edcadastro.BeforeLoadDFMValues;
  edpeso_bruto.BeforeLoadDFMValues;
  edpeso_liquido.BeforeLoadDFMValues;
  edproduto_movimenta_estoque.BeforeLoadDFMValues;
  edproduto_movimenta_estoque_quantidade.BeforeLoadDFMValues;
  edaplicacao.BeforeLoadDFMValues;
  edobservacoes.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  edgrupo_nome.BeforeLoadDFMValues;
  cbxdesativado.BeforeLoadDFMValues;
  cbxgerencial.BeforeLoadDFMValues;
  cbxcomposto.BeforeLoadDFMValues;
  cbxgrade.BeforeLoadDFMValues;
  cbxexcluido.BeforeLoadDFMValues;
  pnlDadosProdutos.BeforeLoadDFMValues;
  btnDadosTab.BeforeLoadDFMValues;
  btnAssociacaoTab.BeforeLoadDFMValues;
  ed_ncm_ncm.BeforeLoadDFMValues;
  pnlProdutoAssociado.BeforeLoadDFMValues;
  edtCodigoProdutoAssociado.BeforeLoadDFMValues;
  edtNomeProdutoAssociado.BeforeLoadDFMValues;
  edtCodBarrasProdutoAssociado.BeforeLoadDFMValues;
  edtStatusProdutoAssociado.BeforeLoadDFMValues;
  edpreco_consignado.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  ProdutosDataset.BeforeLoadDFMValues;
  ProdutosDatasetid.BeforeLoadDFMValues;
  ProdutosDatasetaliado_id.BeforeLoadDFMValues;
  ProdutosDatasetdata_base_id.BeforeLoadDFMValues;
  ProdutosDatasetnome.BeforeLoadDFMValues;
  ProdutosDatasetnome_abreviado.BeforeLoadDFMValues;
  ProdutosDatasetcodigo_barras.BeforeLoadDFMValues;
  ProdutosDatasetcodigo_fabrica.BeforeLoadDFMValues;
  ProdutosDatasetestoque.BeforeLoadDFMValues;
  ProdutosDatasetestoque_retido.BeforeLoadDFMValues;
  ProdutosDatasetestoque_maximo.BeforeLoadDFMValues;
  ProdutosDatasetestoque_minimo.BeforeLoadDFMValues;
  ProdutosDatasetpreco_custo.BeforeLoadDFMValues;
  ProdutosDatasetpreco_venda.BeforeLoadDFMValues;
  ProdutosDatasetpreco_promocional.BeforeLoadDFMValues;
  ProdutosDatasetmargem_lucro.BeforeLoadDFMValues;
  ProdutosDatasetpreco_padrao.BeforeLoadDFMValues;
  ProdutosDatasetdesconto_maximo.BeforeLoadDFMValues;
  ProdutosDatasetvalor_desconto_maximo.BeforeLoadDFMValues;
  ProdutosDatasetcomissao.BeforeLoadDFMValues;
  ProdutosDatasetstatus.BeforeLoadDFMValues;
  ProdutosDatasetunidade_id.BeforeLoadDFMValues;
  ProdutosDatasetsubgrupo_id.BeforeLoadDFMValues;
  ProdutosDatasetdesativado.BeforeLoadDFMValues;
  ProdutosDatasetgerencial.BeforeLoadDFMValues;
  ProdutosDatasetcomposto.BeforeLoadDFMValues;
  ProdutosDatasetgrade.BeforeLoadDFMValues;
  ProdutosDatasetcadastro.BeforeLoadDFMValues;
  ProdutosDatasetpeso_bruto.BeforeLoadDFMValues;
  ProdutosDatasetpeso_liquido.BeforeLoadDFMValues;
  ProdutosDatasetproduto_movimenta_estoque.BeforeLoadDFMValues;
  ProdutosDatasetproduto_movimenta_estoque_quantidade.BeforeLoadDFMValues;
  ProdutosDatasetaplicacao.BeforeLoadDFMValues;
  ProdutosDatasetobservacoes.BeforeLoadDFMValues;
  ProdutosDatasettributacao.BeforeLoadDFMValues;
  ProdutosDatasetcodigo_interno.BeforeLoadDFMValues;
  ProdutosDatasetexcluido.BeforeLoadDFMValues;
  ProdutosDatasetinclusao.BeforeLoadDFMValues;
  ProdutosDatasetalteracao.BeforeLoadDFMValues;
  ProdutosDatasetexclusao.BeforeLoadDFMValues;
  ProdutosDatasetunidadesigla.BeforeLoadDFMValues;
  ProdutosDatasetsubgruponome.BeforeLoadDFMValues;
  ProdutosDatasetsubgrupogruponome.BeforeLoadDFMValues;
  ProdutosDatasetaliadoNome_Fantasia.BeforeLoadDFMValues;
  ProdutosDatasetassociacaofsprodimagem.BeforeLoadDFMValues;
  ProdutosDatasetassociacaofsprodid.BeforeLoadDFMValues;
  ProdutosDatasetassociacaofsprodnome.BeforeLoadDFMValues;
  ProdutosDatasetassociacaofsprodcodigo_barras.BeforeLoadDFMValues;
  ProdutosDatasetassociacaostatus.BeforeLoadDFMValues;
  ProdutosDatasetassociacaoimagem_aprovacao.BeforeLoadDFMValues;
  ProdutosDatasetncmncm.BeforeLoadDFMValues;
  ProdutosDatasetpreco_consignado.BeforeLoadDFMValues;
  XDataClientProdutosGet.BeforeLoadDFMValues;
  try
    Name := 'FViewProdutosEdit';
    Width := 914;
    Height := 623;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 8;
    lbid.Top := 26;
    lbid.Width := 70;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd. Servidor:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbaliado_nome.SetParentComponent(Self);
    lbaliado_nome.Name := 'lbaliado_nome';
    lbaliado_nome.Left := 8;
    lbaliado_nome.Top := 53;
    lbaliado_nome.Width := 33;
    lbaliado_nome.Height := 13;
    lbaliado_nome.Caption := 'Aliado:';
    lbaliado_nome.HeightPercent := 100.000000000000000000;
    lbaliado_nome.WidthPercent := 100.000000000000000000;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 8;
    lbnome.Top := 78;
    lbnome.Width := 31;
    lbnome.Height := 13;
    lbnome.Caption := 'Nome:';
    lbnome.HeightPercent := 100.000000000000000000;
    lbnome.WidthPercent := 100.000000000000000000;
    lbnome_abreviado.SetParentComponent(Self);
    lbnome_abreviado.Name := 'lbnome_abreviado';
    lbnome_abreviado.Left := 8;
    lbnome_abreviado.Top := 105;
    lbnome_abreviado.Width := 83;
    lbnome_abreviado.Height := 13;
    lbnome_abreviado.Caption := 'Nome Abreviado:';
    lbnome_abreviado.HeightPercent := 100.000000000000000000;
    lbnome_abreviado.WidthPercent := 100.000000000000000000;
    lbcodigo_barras.SetParentComponent(Self);
    lbcodigo_barras.Name := 'lbcodigo_barras';
    lbcodigo_barras.Left := 8;
    lbcodigo_barras.Top := 132;
    lbcodigo_barras.Width := 61;
    lbcodigo_barras.Height := 13;
    lbcodigo_barras.Caption := 'C'#243'd. Barras:';
    lbcodigo_barras.HeightPercent := 100.000000000000000000;
    lbcodigo_barras.WidthPercent := 100.000000000000000000;
    lbcodigo_fabrica.SetParentComponent(Self);
    lbcodigo_fabrica.Name := 'lbcodigo_fabrica';
    lbcodigo_fabrica.Left := 8;
    lbcodigo_fabrica.Top := 159;
    lbcodigo_fabrica.Width := 65;
    lbcodigo_fabrica.Height := 13;
    lbcodigo_fabrica.Caption := 'C'#243'd. F'#225'brica:';
    lbcodigo_fabrica.HeightPercent := 100.000000000000000000;
    lbcodigo_fabrica.WidthPercent := 100.000000000000000000;
    lbestoque.SetParentComponent(Self);
    lbestoque.Name := 'lbestoque';
    lbestoque.Left := 8;
    lbestoque.Top := 186;
    lbestoque.Width := 43;
    lbestoque.Height := 13;
    lbestoque.Caption := 'Estoque:';
    lbestoque.HeightPercent := 100.000000000000000000;
    lbestoque.WidthPercent := 100.000000000000000000;
    lbestoque_retido.SetParentComponent(Self);
    lbestoque_retido.Name := 'lbestoque_retido';
    lbestoque_retido.Left := 8;
    lbestoque_retido.Top := 213;
    lbestoque_retido.Width := 67;
    lbestoque_retido.Height := 13;
    lbestoque_retido.Caption := 'Estoque Ret.:';
    lbestoque_retido.HeightPercent := 100.000000000000000000;
    lbestoque_retido.WidthPercent := 100.000000000000000000;
    lbestoque_maximo.SetParentComponent(Self);
    lbestoque_maximo.Name := 'lbestoque_maximo';
    lbestoque_maximo.Left := 541;
    lbestoque_maximo.Top := 134;
    lbestoque_maximo.Width := 66;
    lbestoque_maximo.Height := 13;
    lbestoque_maximo.Caption := 'Estoque Max:';
    lbestoque_maximo.HeightPercent := 100.000000000000000000;
    lbestoque_maximo.WidthPercent := 100.000000000000000000;
    lbestoque_minimo.SetParentComponent(Self);
    lbestoque_minimo.Name := 'lbestoque_minimo';
    lbestoque_minimo.Left := 541;
    lbestoque_minimo.Top := 161;
    lbestoque_minimo.Width := 62;
    lbestoque_minimo.Height := 13;
    lbestoque_minimo.Caption := 'Estoque Min:';
    lbestoque_minimo.HeightPercent := 100.000000000000000000;
    lbestoque_minimo.WidthPercent := 100.000000000000000000;
    lbpreco_custo.SetParentComponent(Self);
    lbpreco_custo.Name := 'lbpreco_custo';
    lbpreco_custo.Left := 541;
    lbpreco_custo.Top := 188;
    lbpreco_custo.Width := 62;
    lbpreco_custo.Height := 13;
    lbpreco_custo.Caption := 'Pre'#231'o Custo:';
    lbpreco_custo.HeightPercent := 100.000000000000000000;
    lbpreco_custo.WidthPercent := 100.000000000000000000;
    lbpreco_venda.SetParentComponent(Self);
    lbpreco_venda.Name := 'lbpreco_venda';
    lbpreco_venda.Left := 541;
    lbpreco_venda.Top := 215;
    lbpreco_venda.Width := 64;
    lbpreco_venda.Height := 13;
    lbpreco_venda.Caption := 'Pre'#231'o Venda:';
    lbpreco_venda.HeightPercent := 100.000000000000000000;
    lbpreco_venda.WidthPercent := 100.000000000000000000;
    lbpreco_promocional.SetParentComponent(Self);
    lbpreco_promocional.Name := 'lbpreco_promocional';
    lbpreco_promocional.Left := 8;
    lbpreco_promocional.Top := 241;
    lbpreco_promocional.Width := 91;
    lbpreco_promocional.Height := 13;
    lbpreco_promocional.Caption := 'Pre'#231'o Promocional:';
    lbpreco_promocional.HeightPercent := 100.000000000000000000;
    lbpreco_promocional.WidthPercent := 100.000000000000000000;
    lbmargem_lucro.SetParentComponent(Self);
    lbmargem_lucro.Name := 'lbmargem_lucro';
    lbmargem_lucro.Left := 8;
    lbmargem_lucro.Top := 268;
    lbmargem_lucro.Width := 71;
    lbmargem_lucro.Height := 13;
    lbmargem_lucro.Caption := 'Margem Lucro:';
    lbmargem_lucro.HeightPercent := 100.000000000000000000;
    lbmargem_lucro.WidthPercent := 100.000000000000000000;
    lbpreco_padrao.SetParentComponent(Self);
    lbpreco_padrao.Name := 'lbpreco_padrao';
    lbpreco_padrao.Left := 8;
    lbpreco_padrao.Top := 295;
    lbpreco_padrao.Width := 68;
    lbpreco_padrao.Height := 13;
    lbpreco_padrao.Caption := 'Pre'#231'o Padr'#227'o:';
    lbpreco_padrao.HeightPercent := 100.000000000000000000;
    lbpreco_padrao.WidthPercent := 100.000000000000000000;
    lbdesconto_maximo.SetParentComponent(Self);
    lbdesconto_maximo.Name := 'lbdesconto_maximo';
    lbdesconto_maximo.Left := 8;
    lbdesconto_maximo.Top := 322;
    lbdesconto_maximo.Width := 72;
    lbdesconto_maximo.Height := 13;
    lbdesconto_maximo.Caption := 'Desconto Max:';
    lbdesconto_maximo.HeightPercent := 100.000000000000000000;
    lbdesconto_maximo.WidthPercent := 100.000000000000000000;
    lbvalor_desconto_maximo.SetParentComponent(Self);
    lbvalor_desconto_maximo.Name := 'lbvalor_desconto_maximo';
    lbvalor_desconto_maximo.Left := 8;
    lbvalor_desconto_maximo.Top := 349;
    lbvalor_desconto_maximo.Width := 99;
    lbvalor_desconto_maximo.Height := 13;
    lbvalor_desconto_maximo.Caption := 'Valor Desconto Max:';
    lbvalor_desconto_maximo.HeightPercent := 100.000000000000000000;
    lbvalor_desconto_maximo.WidthPercent := 100.000000000000000000;
    lbcomissao.SetParentComponent(Self);
    lbcomissao.Name := 'lbcomissao';
    lbcomissao.Left := 264;
    lbcomissao.Top := 26;
    lbcomissao.Width := 49;
    lbcomissao.Height := 13;
    lbcomissao.Caption := 'Comiss'#227'o:';
    lbcomissao.HeightPercent := 100.000000000000000000;
    lbcomissao.WidthPercent := 100.000000000000000000;
    lbstatus.SetParentComponent(Self);
    lbstatus.Name := 'lbstatus';
    lbstatus.Left := 264;
    lbstatus.Top := 53;
    lbstatus.Width := 35;
    lbstatus.Height := 13;
    lbstatus.Caption := 'Status:';
    lbstatus.HeightPercent := 100.000000000000000000;
    lbstatus.WidthPercent := 100.000000000000000000;
    lbunidade_nome.SetParentComponent(Self);
    lbunidade_nome.Name := 'lbunidade_nome';
    lbunidade_nome.Left := 264;
    lbunidade_nome.Top := 80;
    lbunidade_nome.Width := 43;
    lbunidade_nome.Height := 13;
    lbunidade_nome.Caption := 'Unidade:';
    lbunidade_nome.HeightPercent := 100.000000000000000000;
    lbunidade_nome.WidthPercent := 100.000000000000000000;
    lbsubgrupo_nome.SetParentComponent(Self);
    lbsubgrupo_nome.Name := 'lbsubgrupo_nome';
    lbsubgrupo_nome.Left := 264;
    lbsubgrupo_nome.Top := 107;
    lbsubgrupo_nome.Width := 50;
    lbsubgrupo_nome.Height := 13;
    lbsubgrupo_nome.Caption := 'Subgrupo:';
    lbsubgrupo_nome.HeightPercent := 100.000000000000000000;
    lbsubgrupo_nome.WidthPercent := 100.000000000000000000;
    lbdesativado.SetParentComponent(Self);
    lbdesativado.Name := 'lbdesativado';
    lbdesativado.Left := 264;
    lbdesativado.Top := 134;
    lbdesativado.Width := 59;
    lbdesativado.Height := 13;
    lbdesativado.Caption := 'Desativado?';
    lbdesativado.HeightPercent := 100.000000000000000000;
    lbdesativado.WidthPercent := 100.000000000000000000;
    lbgerencial.SetParentComponent(Self);
    lbgerencial.Name := 'lbgerencial';
    lbgerencial.Left := 264;
    lbgerencial.Top := 161;
    lbgerencial.Width := 49;
    lbgerencial.Height := 13;
    lbgerencial.Caption := 'Gerencial?';
    lbgerencial.HeightPercent := 100.000000000000000000;
    lbgerencial.WidthPercent := 100.000000000000000000;
    lbcomposto.SetParentComponent(Self);
    lbcomposto.Name := 'lbcomposto';
    lbcomposto.Left := 264;
    lbcomposto.Top := 188;
    lbcomposto.Width := 53;
    lbcomposto.Height := 13;
    lbcomposto.Caption := 'Composto?';
    lbcomposto.HeightPercent := 100.000000000000000000;
    lbcomposto.WidthPercent := 100.000000000000000000;
    lbgrade.SetParentComponent(Self);
    lbgrade.Name := 'lbgrade';
    lbgrade.Left := 264;
    lbgrade.Top := 215;
    lbgrade.Width := 34;
    lbgrade.Height := 13;
    lbgrade.Caption := 'Grade?';
    lbgrade.HeightPercent := 100.000000000000000000;
    lbgrade.WidthPercent := 100.000000000000000000;
    lbcadastro.SetParentComponent(Self);
    lbcadastro.Name := 'lbcadastro';
    lbcadastro.Left := 264;
    lbcadastro.Top := 242;
    lbcadastro.Width := 74;
    lbcadastro.Height := 13;
    lbcadastro.Caption := 'Data Cadastro:';
    lbcadastro.HeightPercent := 100.000000000000000000;
    lbcadastro.WidthPercent := 100.000000000000000000;
    lbpeso_bruto.SetParentComponent(Self);
    lbpeso_bruto.Name := 'lbpeso_bruto';
    lbpeso_bruto.Left := 264;
    lbpeso_bruto.Top := 269;
    lbpeso_bruto.Width := 56;
    lbpeso_bruto.Height := 13;
    lbpeso_bruto.Caption := 'Peso Bruto:';
    lbpeso_bruto.HeightPercent := 100.000000000000000000;
    lbpeso_bruto.WidthPercent := 100.000000000000000000;
    lbpeso_liquido.SetParentComponent(Self);
    lbpeso_liquido.Name := 'lbpeso_liquido';
    lbpeso_liquido.Left := 264;
    lbpeso_liquido.Top := 296;
    lbpeso_liquido.Width := 63;
    lbpeso_liquido.Height := 13;
    lbpeso_liquido.Caption := 'Peso L'#237'quido:';
    lbpeso_liquido.HeightPercent := 100.000000000000000000;
    lbpeso_liquido.WidthPercent := 100.000000000000000000;
    lbproduto_movimenta_estoque.SetParentComponent(Self);
    lbproduto_movimenta_estoque.Name := 'lbproduto_movimenta_estoque';
    lbproduto_movimenta_estoque.Left := 264;
    lbproduto_movimenta_estoque.Top := 323;
    lbproduto_movimenta_estoque.Width := 98;
    lbproduto_movimenta_estoque.Height := 13;
    lbproduto_movimenta_estoque.Caption := 'Movimenta Estoque:';
    lbproduto_movimenta_estoque.HeightPercent := 100.000000000000000000;
    lbproduto_movimenta_estoque.WidthPercent := 100.000000000000000000;
    lbproduto_movimenta_estoque_quantidade.SetParentComponent(Self);
    lbproduto_movimenta_estoque_quantidade.Name := 'lbproduto_movimenta_estoque_quantidade';
    lbproduto_movimenta_estoque_quantidade.Left := 264;
    lbproduto_movimenta_estoque_quantidade.Top := 350;
    lbproduto_movimenta_estoque_quantidade.Width := 135;
    lbproduto_movimenta_estoque_quantidade.Height := 13;
    lbproduto_movimenta_estoque_quantidade.Caption := 'Movimenta Estoque Quant.:';
    lbproduto_movimenta_estoque_quantidade.HeightPercent := 100.000000000000000000;
    lbproduto_movimenta_estoque_quantidade.WidthPercent := 100.000000000000000000;
    lbaplicacao.SetParentComponent(Self);
    lbaplicacao.Name := 'lbaplicacao';
    lbaplicacao.Left := 541;
    lbaplicacao.Top := 241;
    lbaplicacao.Width := 49;
    lbaplicacao.Height := 13;
    lbaplicacao.Caption := 'Aplica'#231#227'o:';
    lbaplicacao.HeightPercent := 100.000000000000000000;
    lbaplicacao.WidthPercent := 100.000000000000000000;
    lbobservacoes.SetParentComponent(Self);
    lbobservacoes.Name := 'lbobservacoes';
    lbobservacoes.Left := 541;
    lbobservacoes.Top := 268;
    lbobservacoes.Width := 67;
    lbobservacoes.Height := 13;
    lbobservacoes.Caption := 'Observa'#231#245'es:';
    lbobservacoes.HeightPercent := 100.000000000000000000;
    lbobservacoes.WidthPercent := 100.000000000000000000;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 541;
    lbcodigo_interno.Top := 293;
    lbcodigo_interno.Width := 87;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'C'#243'd. Retaguarda:';
    lbcodigo_interno.HeightPercent := 100.000000000000000000;
    lbcodigo_interno.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 541;
    lbexcluido.Top := 26;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 541;
    lbinclusao.Top := 53;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 541;
    lbalteracao.Top := 80;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 541;
    lbexclusao.Top := 107;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    lbgrupo_nome.SetParentComponent(Self);
    lbgrupo_nome.Name := 'lbgrupo_nome';
    lbgrupo_nome.Left := 541;
    lbgrupo_nome.Top := 320;
    lbgrupo_nome.Width := 33;
    lbgrupo_nome.Height := 13;
    lbgrupo_nome.Caption := 'Grupo:';
    lbgrupo_nome.HeightPercent := 100.000000000000000000;
    lbgrupo_nome.WidthPercent := 100.000000000000000000;
    lbncm_ncm.SetParentComponent(Self);
    lbncm_ncm.Name := 'lbncm_ncm';
    lbncm_ncm.Left := 541;
    lbncm_ncm.Top := 347;
    lbncm_ncm.Width := 24;
    lbncm_ncm.Height := 13;
    lbncm_ncm.Caption := 'Ncm:';
    lbncm_ncm.HeightPercent := 100.000000000000000000;
    lbncm_ncm.WidthPercent := 100.000000000000000000;
    lblCodigoProdutoAssociado.SetParentComponent(Self);
    lblCodigoProdutoAssociado.Name := 'lblCodigoProdutoAssociado';
    lblCodigoProdutoAssociado.Left := 8;
    lblCodigoProdutoAssociado.Top := 422;
    lblCodigoProdutoAssociado.Width := 23;
    lblCodigoProdutoAssociado.Height := 13;
    lblCodigoProdutoAssociado.Caption := 'C'#243'd:';
    lblCodigoProdutoAssociado.Color := clBtnFace;
    lblCodigoProdutoAssociado.HeightPercent := 100.000000000000000000;
    lblCodigoProdutoAssociado.WidthPercent := 100.000000000000000000;
    lblNomeProdutoAssociado.SetParentComponent(Self);
    lblNomeProdutoAssociado.Name := 'lblNomeProdutoAssociado';
    lblNomeProdutoAssociado.Left := 8;
    lblNomeProdutoAssociado.Top := 452;
    lblNomeProdutoAssociado.Width := 31;
    lblNomeProdutoAssociado.Height := 13;
    lblNomeProdutoAssociado.Caption := 'Nome:';
    lblNomeProdutoAssociado.Color := clBtnFace;
    lblNomeProdutoAssociado.HeightPercent := 100.000000000000000000;
    lblNomeProdutoAssociado.WidthPercent := 100.000000000000000000;
    lblCodBarrasProdutoAssociado.SetParentComponent(Self);
    lblCodBarrasProdutoAssociado.Name := 'lblCodBarrasProdutoAssociado';
    lblCodBarrasProdutoAssociado.Left := 8;
    lblCodBarrasProdutoAssociado.Top := 478;
    lblCodBarrasProdutoAssociado.Width := 61;
    lblCodBarrasProdutoAssociado.Height := 13;
    lblCodBarrasProdutoAssociado.Caption := 'C'#243'd. Barras:';
    lblCodBarrasProdutoAssociado.Color := clBtnFace;
    lblCodBarrasProdutoAssociado.HeightPercent := 100.000000000000000000;
    lblCodBarrasProdutoAssociado.WidthPercent := 100.000000000000000000;
    lblStatusProdutoAssociado.SetParentComponent(Self);
    lblStatusProdutoAssociado.Name := 'lblStatusProdutoAssociado';
    lblStatusProdutoAssociado.Left := 8;
    lblStatusProdutoAssociado.Top := 506;
    lblStatusProdutoAssociado.Width := 35;
    lblStatusProdutoAssociado.Height := 13;
    lblStatusProdutoAssociado.Caption := 'Status:';
    lblStatusProdutoAssociado.Color := clBtnFace;
    lblStatusProdutoAssociado.HeightPercent := 100.000000000000000000;
    lblStatusProdutoAssociado.WidthPercent := 100.000000000000000000;
    imgProduto.SetParentComponent(Self);
    imgProduto.Name := 'imgProduto';
    imgProduto.Left := 8;
    imgProduto.Top := 527;
    imgProduto.Width := 100;
    imgProduto.Height := 26;
    imgProduto.HeightPercent := 100.000000000000000000;
    imgProduto.WidthPercent := 100.000000000000000000;
    imgProduto.ChildOrder := 91;
    lbpreco_consignado.SetParentComponent(Self);
    lbpreco_consignado.Name := 'lbpreco_consignado';
    lbpreco_consignado.Left := 8;
    lbpreco_consignado.Top := 376;
    lbpreco_consignado.Width := 90;
    lbpreco_consignado.Height := 13;
    lbpreco_consignado.Caption := 'Pre'#231'o Consignado:';
    lbpreco_consignado.HeightPercent := 100.000000000000000000;
    lbpreco_consignado.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 792;
    btCancel.Top := 48;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 117;
    edid.Top := 23;
    edid.Width := 120;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    edaliado_nome.SetParentComponent(Self);
    edaliado_nome.Name := 'edaliado_nome';
    edaliado_nome.Left := 117;
    edaliado_nome.Top := 50;
    edaliado_nome.Width := 120;
    edaliado_nome.Height := 21;
    edaliado_nome.Enabled := False;
    edaliado_nome.HeightPercent := 100.000000000000000000;
    edaliado_nome.TabOrder := 7;
    edaliado_nome.Text := 'edaliado_nome';
    edaliado_nome.WidthPercent := 100.000000000000000000;
    edaliado_nome.DataField := 'aliado.Nome_Fantasia';
    edaliado_nome.DataSource := DataSource;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 117;
    ednome.Top := 75;
    ednome.Width := 120;
    ednome.Height := 21;
    ednome.Enabled := False;
    ednome.HeightPercent := 100.000000000000000000;
    ednome.TabOrder := 9;
    ednome.Text := 'ednome';
    ednome.WidthPercent := 100.000000000000000000;
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    ednome_abreviado.SetParentComponent(Self);
    ednome_abreviado.Name := 'ednome_abreviado';
    ednome_abreviado.Left := 117;
    ednome_abreviado.Top := 102;
    ednome_abreviado.Width := 120;
    ednome_abreviado.Height := 21;
    ednome_abreviado.Enabled := False;
    ednome_abreviado.HeightPercent := 100.000000000000000000;
    ednome_abreviado.TabOrder := 10;
    ednome_abreviado.Text := 'ednome_abreviado';
    ednome_abreviado.WidthPercent := 100.000000000000000000;
    ednome_abreviado.DataField := 'nome_abreviado';
    ednome_abreviado.DataSource := DataSource;
    edcodigo_barras.SetParentComponent(Self);
    edcodigo_barras.Name := 'edcodigo_barras';
    edcodigo_barras.Left := 117;
    edcodigo_barras.Top := 129;
    edcodigo_barras.Width := 120;
    edcodigo_barras.Height := 21;
    edcodigo_barras.Enabled := False;
    edcodigo_barras.HeightPercent := 100.000000000000000000;
    edcodigo_barras.TabOrder := 11;
    edcodigo_barras.Text := 'edcodigo_barras';
    edcodigo_barras.WidthPercent := 100.000000000000000000;
    edcodigo_barras.DataField := 'codigo_barras';
    edcodigo_barras.DataSource := DataSource;
    edcodigo_fabrica.SetParentComponent(Self);
    edcodigo_fabrica.Name := 'edcodigo_fabrica';
    edcodigo_fabrica.Left := 117;
    edcodigo_fabrica.Top := 156;
    edcodigo_fabrica.Width := 120;
    edcodigo_fabrica.Height := 21;
    edcodigo_fabrica.Enabled := False;
    edcodigo_fabrica.HeightPercent := 100.000000000000000000;
    edcodigo_fabrica.TabOrder := 12;
    edcodigo_fabrica.Text := 'edcodigo_fabrica';
    edcodigo_fabrica.WidthPercent := 100.000000000000000000;
    edcodigo_fabrica.DataField := 'codigo_fabrica';
    edcodigo_fabrica.DataSource := DataSource;
    edestoque.SetParentComponent(Self);
    edestoque.Name := 'edestoque';
    edestoque.Left := 117;
    edestoque.Top := 183;
    edestoque.Width := 120;
    edestoque.Height := 21;
    edestoque.Enabled := False;
    edestoque.HeightPercent := 100.000000000000000000;
    edestoque.TabOrder := 13;
    edestoque.Text := 'edestoque';
    edestoque.WidthPercent := 100.000000000000000000;
    edestoque.DataField := 'estoque';
    edestoque.DataSource := DataSource;
    edestoque_retido.SetParentComponent(Self);
    edestoque_retido.Name := 'edestoque_retido';
    edestoque_retido.Left := 117;
    edestoque_retido.Top := 210;
    edestoque_retido.Width := 120;
    edestoque_retido.Height := 21;
    edestoque_retido.Enabled := False;
    edestoque_retido.HeightPercent := 100.000000000000000000;
    edestoque_retido.TabOrder := 14;
    edestoque_retido.Text := 'edestoque_retido';
    edestoque_retido.WidthPercent := 100.000000000000000000;
    edestoque_retido.DataField := 'estoque_retido';
    edestoque_retido.DataSource := DataSource;
    edestoque_maximo.SetParentComponent(Self);
    edestoque_maximo.Name := 'edestoque_maximo';
    edestoque_maximo.Left := 650;
    edestoque_maximo.Top := 131;
    edestoque_maximo.Width := 120;
    edestoque_maximo.Height := 21;
    edestoque_maximo.Enabled := False;
    edestoque_maximo.HeightPercent := 100.000000000000000000;
    edestoque_maximo.TabOrder := 15;
    edestoque_maximo.Text := 'edestoque_maximo';
    edestoque_maximo.WidthPercent := 100.000000000000000000;
    edestoque_maximo.DataField := 'estoque_maximo';
    edestoque_maximo.DataSource := DataSource;
    edestoque_minimo.SetParentComponent(Self);
    edestoque_minimo.Name := 'edestoque_minimo';
    edestoque_minimo.Left := 650;
    edestoque_minimo.Top := 158;
    edestoque_minimo.Width := 120;
    edestoque_minimo.Height := 21;
    edestoque_minimo.Enabled := False;
    edestoque_minimo.HeightPercent := 100.000000000000000000;
    edestoque_minimo.TabOrder := 16;
    edestoque_minimo.Text := 'edestoque_minimo';
    edestoque_minimo.WidthPercent := 100.000000000000000000;
    edestoque_minimo.DataField := 'estoque_minimo';
    edestoque_minimo.DataSource := DataSource;
    edpreco_custo.SetParentComponent(Self);
    edpreco_custo.Name := 'edpreco_custo';
    edpreco_custo.Left := 650;
    edpreco_custo.Top := 185;
    edpreco_custo.Width := 120;
    edpreco_custo.Height := 21;
    edpreco_custo.Enabled := False;
    edpreco_custo.HeightPercent := 100.000000000000000000;
    edpreco_custo.TabOrder := 17;
    edpreco_custo.Text := 'edpreco_custo';
    edpreco_custo.WidthPercent := 100.000000000000000000;
    edpreco_custo.DataField := 'preco_custo';
    edpreco_custo.DataSource := DataSource;
    edpreco_venda.SetParentComponent(Self);
    edpreco_venda.Name := 'edpreco_venda';
    edpreco_venda.Left := 650;
    edpreco_venda.Top := 212;
    edpreco_venda.Width := 120;
    edpreco_venda.Height := 21;
    edpreco_venda.Enabled := False;
    edpreco_venda.HeightPercent := 100.000000000000000000;
    edpreco_venda.TabOrder := 18;
    edpreco_venda.Text := 'edpreco_venda';
    edpreco_venda.WidthPercent := 100.000000000000000000;
    edpreco_venda.DataField := 'preco_venda';
    edpreco_venda.DataSource := DataSource;
    edpreco_promocional.SetParentComponent(Self);
    edpreco_promocional.Name := 'edpreco_promocional';
    edpreco_promocional.Left := 117;
    edpreco_promocional.Top := 238;
    edpreco_promocional.Width := 120;
    edpreco_promocional.Height := 21;
    edpreco_promocional.Enabled := False;
    edpreco_promocional.HeightPercent := 100.000000000000000000;
    edpreco_promocional.TabOrder := 19;
    edpreco_promocional.Text := 'edpreco_promocional';
    edpreco_promocional.WidthPercent := 100.000000000000000000;
    edpreco_promocional.DataField := 'preco_promocional';
    edpreco_promocional.DataSource := DataSource;
    edmargem_lucro.SetParentComponent(Self);
    edmargem_lucro.Name := 'edmargem_lucro';
    edmargem_lucro.Left := 117;
    edmargem_lucro.Top := 265;
    edmargem_lucro.Width := 120;
    edmargem_lucro.Height := 21;
    edmargem_lucro.Enabled := False;
    edmargem_lucro.HeightPercent := 100.000000000000000000;
    edmargem_lucro.TabOrder := 20;
    edmargem_lucro.Text := 'edmargem_lucro';
    edmargem_lucro.WidthPercent := 100.000000000000000000;
    edmargem_lucro.DataField := 'margem_lucro';
    edmargem_lucro.DataSource := DataSource;
    edpreco_padrao.SetParentComponent(Self);
    edpreco_padrao.Name := 'edpreco_padrao';
    edpreco_padrao.Left := 117;
    edpreco_padrao.Top := 292;
    edpreco_padrao.Width := 120;
    edpreco_padrao.Height := 21;
    edpreco_padrao.Enabled := False;
    edpreco_padrao.HeightPercent := 100.000000000000000000;
    edpreco_padrao.TabOrder := 21;
    edpreco_padrao.Text := 'edpreco_padrao';
    edpreco_padrao.WidthPercent := 100.000000000000000000;
    edpreco_padrao.DataField := 'preco_padrao';
    edpreco_padrao.DataSource := DataSource;
    eddesconto_maximo.SetParentComponent(Self);
    eddesconto_maximo.Name := 'eddesconto_maximo';
    eddesconto_maximo.Left := 117;
    eddesconto_maximo.Top := 319;
    eddesconto_maximo.Width := 120;
    eddesconto_maximo.Height := 21;
    eddesconto_maximo.Enabled := False;
    eddesconto_maximo.HeightPercent := 100.000000000000000000;
    eddesconto_maximo.TabOrder := 22;
    eddesconto_maximo.Text := 'eddesconto_maximo';
    eddesconto_maximo.WidthPercent := 100.000000000000000000;
    eddesconto_maximo.DataField := 'desconto_maximo';
    eddesconto_maximo.DataSource := DataSource;
    edvalor_desconto_maximo.SetParentComponent(Self);
    edvalor_desconto_maximo.Name := 'edvalor_desconto_maximo';
    edvalor_desconto_maximo.Left := 117;
    edvalor_desconto_maximo.Top := 346;
    edvalor_desconto_maximo.Width := 120;
    edvalor_desconto_maximo.Height := 21;
    edvalor_desconto_maximo.Enabled := False;
    edvalor_desconto_maximo.HeightPercent := 100.000000000000000000;
    edvalor_desconto_maximo.TabOrder := 23;
    edvalor_desconto_maximo.Text := 'edvalor_desconto_maximo';
    edvalor_desconto_maximo.WidthPercent := 100.000000000000000000;
    edvalor_desconto_maximo.DataField := 'valor_desconto_maximo';
    edvalor_desconto_maximo.DataSource := DataSource;
    edcomissao.SetParentComponent(Self);
    edcomissao.Name := 'edcomissao';
    edcomissao.Left := 405;
    edcomissao.Top := 23;
    edcomissao.Width := 120;
    edcomissao.Height := 21;
    edcomissao.Enabled := False;
    edcomissao.HeightPercent := 100.000000000000000000;
    edcomissao.TabOrder := 24;
    edcomissao.Text := 'edcomissao';
    edcomissao.WidthPercent := 100.000000000000000000;
    edcomissao.DataField := 'comissao';
    edcomissao.DataSource := DataSource;
    edstatus.SetParentComponent(Self);
    edstatus.Name := 'edstatus';
    edstatus.Left := 405;
    edstatus.Top := 50;
    edstatus.Width := 120;
    edstatus.Height := 21;
    edstatus.Enabled := False;
    edstatus.HeightPercent := 100.000000000000000000;
    edstatus.TabOrder := 25;
    edstatus.Text := 'edstatus';
    edstatus.WidthPercent := 100.000000000000000000;
    edstatus.DataField := 'status';
    edstatus.DataSource := DataSource;
    edunidade_nome.SetParentComponent(Self);
    edunidade_nome.Name := 'edunidade_nome';
    edunidade_nome.Left := 405;
    edunidade_nome.Top := 77;
    edunidade_nome.Width := 120;
    edunidade_nome.Height := 21;
    edunidade_nome.Enabled := False;
    edunidade_nome.HeightPercent := 100.000000000000000000;
    edunidade_nome.TabOrder := 26;
    edunidade_nome.Text := 'edunidade_nome';
    edunidade_nome.WidthPercent := 100.000000000000000000;
    edunidade_nome.DataField := 'unidade.sigla';
    edunidade_nome.DataSource := DataSource;
    edsubgrupo_nome.SetParentComponent(Self);
    edsubgrupo_nome.Name := 'edsubgrupo_nome';
    edsubgrupo_nome.Left := 405;
    edsubgrupo_nome.Top := 104;
    edsubgrupo_nome.Width := 120;
    edsubgrupo_nome.Height := 21;
    edsubgrupo_nome.Enabled := False;
    edsubgrupo_nome.HeightPercent := 100.000000000000000000;
    edsubgrupo_nome.TabOrder := 27;
    edsubgrupo_nome.Text := 'edsubgrupo_nome';
    edsubgrupo_nome.WidthPercent := 100.000000000000000000;
    edsubgrupo_nome.DataField := 'subgrupo.nome';
    edsubgrupo_nome.DataSource := DataSource;
    edcadastro.SetParentComponent(Self);
    edcadastro.Name := 'edcadastro';
    edcadastro.Left := 405;
    edcadastro.Top := 239;
    edcadastro.Width := 120;
    edcadastro.Height := 21;
    edcadastro.Enabled := False;
    edcadastro.HeightPercent := 100.000000000000000000;
    edcadastro.TabOrder := 32;
    edcadastro.Text := 'edcadastro';
    edcadastro.WidthPercent := 100.000000000000000000;
    edcadastro.DataField := 'cadastro';
    edcadastro.DataSource := DataSource;
    edpeso_bruto.SetParentComponent(Self);
    edpeso_bruto.Name := 'edpeso_bruto';
    edpeso_bruto.Left := 405;
    edpeso_bruto.Top := 266;
    edpeso_bruto.Width := 120;
    edpeso_bruto.Height := 21;
    edpeso_bruto.Enabled := False;
    edpeso_bruto.HeightPercent := 100.000000000000000000;
    edpeso_bruto.TabOrder := 33;
    edpeso_bruto.Text := 'edpeso_bruto';
    edpeso_bruto.WidthPercent := 100.000000000000000000;
    edpeso_bruto.DataField := 'peso_bruto';
    edpeso_bruto.DataSource := DataSource;
    edpeso_liquido.SetParentComponent(Self);
    edpeso_liquido.Name := 'edpeso_liquido';
    edpeso_liquido.Left := 405;
    edpeso_liquido.Top := 293;
    edpeso_liquido.Width := 120;
    edpeso_liquido.Height := 21;
    edpeso_liquido.Enabled := False;
    edpeso_liquido.HeightPercent := 100.000000000000000000;
    edpeso_liquido.TabOrder := 34;
    edpeso_liquido.Text := 'edpeso_liquido';
    edpeso_liquido.WidthPercent := 100.000000000000000000;
    edpeso_liquido.DataField := 'peso_liquido';
    edpeso_liquido.DataSource := DataSource;
    edproduto_movimenta_estoque.SetParentComponent(Self);
    edproduto_movimenta_estoque.Name := 'edproduto_movimenta_estoque';
    edproduto_movimenta_estoque.Left := 405;
    edproduto_movimenta_estoque.Top := 320;
    edproduto_movimenta_estoque.Width := 120;
    edproduto_movimenta_estoque.Height := 21;
    edproduto_movimenta_estoque.Enabled := False;
    edproduto_movimenta_estoque.HeightPercent := 100.000000000000000000;
    edproduto_movimenta_estoque.TabOrder := 35;
    edproduto_movimenta_estoque.Text := 'edproduto_movimenta_estoque';
    edproduto_movimenta_estoque.WidthPercent := 100.000000000000000000;
    edproduto_movimenta_estoque.DataField := 'produto_movimenta_estoque';
    edproduto_movimenta_estoque.DataSource := DataSource;
    edproduto_movimenta_estoque_quantidade.SetParentComponent(Self);
    edproduto_movimenta_estoque_quantidade.Name := 'edproduto_movimenta_estoque_quantidade';
    edproduto_movimenta_estoque_quantidade.Left := 405;
    edproduto_movimenta_estoque_quantidade.Top := 347;
    edproduto_movimenta_estoque_quantidade.Width := 120;
    edproduto_movimenta_estoque_quantidade.Height := 21;
    edproduto_movimenta_estoque_quantidade.Enabled := False;
    edproduto_movimenta_estoque_quantidade.HeightPercent := 100.000000000000000000;
    edproduto_movimenta_estoque_quantidade.TabOrder := 36;
    edproduto_movimenta_estoque_quantidade.Text := 'edproduto_movimenta_estoque_quantidade';
    edproduto_movimenta_estoque_quantidade.WidthPercent := 100.000000000000000000;
    edproduto_movimenta_estoque_quantidade.DataField := 'produto_movimenta_estoque_quantidade';
    edproduto_movimenta_estoque_quantidade.DataSource := DataSource;
    edaplicacao.SetParentComponent(Self);
    edaplicacao.Name := 'edaplicacao';
    edaplicacao.Left := 650;
    edaplicacao.Top := 238;
    edaplicacao.Width := 120;
    edaplicacao.Height := 21;
    edaplicacao.Enabled := False;
    edaplicacao.HeightPercent := 100.000000000000000000;
    edaplicacao.TabOrder := 37;
    edaplicacao.Text := 'edaplicacao';
    edaplicacao.WidthPercent := 100.000000000000000000;
    edaplicacao.DataField := 'aplicacao';
    edaplicacao.DataSource := DataSource;
    edobservacoes.SetParentComponent(Self);
    edobservacoes.Name := 'edobservacoes';
    edobservacoes.Left := 650;
    edobservacoes.Top := 265;
    edobservacoes.Width := 120;
    edobservacoes.Height := 21;
    edobservacoes.Enabled := False;
    edobservacoes.HeightPercent := 100.000000000000000000;
    edobservacoes.TabOrder := 38;
    edobservacoes.Text := 'edobservacoes';
    edobservacoes.WidthPercent := 100.000000000000000000;
    edobservacoes.DataField := 'observacoes';
    edobservacoes.DataSource := DataSource;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 650;
    edcodigo_interno.Top := 290;
    edcodigo_interno.Width := 120;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := False;
    edcodigo_interno.HeightPercent := 100.000000000000000000;
    edcodigo_interno.TabOrder := 40;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.WidthPercent := 100.000000000000000000;
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 650;
    edinclusao.Top := 50;
    edinclusao.Width := 120;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 42;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 650;
    edalteracao.Top := 77;
    edalteracao.Width := 120;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 43;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 650;
    edexclusao.Top := 104;
    edexclusao.Width := 120;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 44;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    edgrupo_nome.SetParentComponent(Self);
    edgrupo_nome.Name := 'edgrupo_nome';
    edgrupo_nome.Left := 653;
    edgrupo_nome.Top := 317;
    edgrupo_nome.Width := 120;
    edgrupo_nome.Height := 21;
    edgrupo_nome.ChildOrder := 76;
    edgrupo_nome.Enabled := False;
    edgrupo_nome.HeightPercent := 100.000000000000000000;
    edgrupo_nome.TabOrder := 27;
    edgrupo_nome.Text := 'edsubgrupo_nome';
    edgrupo_nome.WidthPercent := 100.000000000000000000;
    edgrupo_nome.DataField := 'subgrupo.grupo.nome';
    edgrupo_nome.DataSource := DataSource;
    cbxdesativado.SetParentComponent(Self);
    cbxdesativado.Name := 'cbxdesativado';
    cbxdesativado.Left := 405;
    cbxdesativado.Top := 131;
    cbxdesativado.Width := 120;
    cbxdesativado.Height := 22;
    cbxdesativado.Caption := 'cbxdesativado';
    cbxdesativado.ChildOrder := 33;
    cbxdesativado.Enabled := False;
    cbxdesativado.HeightPercent := 100.000000000000000000;
    cbxdesativado.WidthPercent := 100.000000000000000000;
    cbxdesativado.DataField := 'desativado';
    cbxdesativado.DataSource := DataSource;
    cbxgerencial.SetParentComponent(Self);
    cbxgerencial.Name := 'cbxgerencial';
    cbxgerencial.Left := 405;
    cbxgerencial.Top := 158;
    cbxgerencial.Width := 120;
    cbxgerencial.Height := 22;
    cbxgerencial.Caption := 'cbxgerencial';
    cbxgerencial.ChildOrder := 33;
    cbxgerencial.Enabled := False;
    cbxgerencial.HeightPercent := 100.000000000000000000;
    cbxgerencial.WidthPercent := 100.000000000000000000;
    cbxgerencial.DataField := 'gerencial';
    cbxgerencial.DataSource := DataSource;
    cbxcomposto.SetParentComponent(Self);
    cbxcomposto.Name := 'cbxcomposto';
    cbxcomposto.Left := 405;
    cbxcomposto.Top := 185;
    cbxcomposto.Width := 120;
    cbxcomposto.Height := 22;
    cbxcomposto.Caption := 'cbxcomposto';
    cbxcomposto.ChildOrder := 33;
    cbxcomposto.Enabled := False;
    cbxcomposto.HeightPercent := 100.000000000000000000;
    cbxcomposto.WidthPercent := 100.000000000000000000;
    cbxcomposto.DataField := 'composto';
    cbxcomposto.DataSource := DataSource;
    cbxgrade.SetParentComponent(Self);
    cbxgrade.Name := 'cbxgrade';
    cbxgrade.Left := 405;
    cbxgrade.Top := 210;
    cbxgrade.Width := 120;
    cbxgrade.Height := 22;
    cbxgrade.Caption := 'cbxgrade';
    cbxgrade.ChildOrder := 33;
    cbxgrade.Enabled := False;
    cbxgrade.HeightPercent := 100.000000000000000000;
    cbxgrade.WidthPercent := 100.000000000000000000;
    cbxgrade.DataField := 'grade';
    cbxgrade.DataSource := DataSource;
    cbxexcluido.SetParentComponent(Self);
    cbxexcluido.Name := 'cbxexcluido';
    cbxexcluido.Left := 650;
    cbxexcluido.Top := 22;
    cbxexcluido.Width := 120;
    cbxexcluido.Height := 22;
    cbxexcluido.Caption := 'cbxexcluido';
    cbxexcluido.ChildOrder := 33;
    cbxexcluido.Enabled := False;
    cbxexcluido.HeightPercent := 100.000000000000000000;
    cbxexcluido.WidthPercent := 100.000000000000000000;
    cbxexcluido.DataField := 'excluido';
    cbxexcluido.DataSource := DataSource;
    pnlDadosProdutos.SetParentComponent(Self);
    pnlDadosProdutos.Name := 'pnlDadosProdutos';
    pnlDadosProdutos.Left := 8;
    pnlDadosProdutos.Top := 0;
    pnlDadosProdutos.Width := 905;
    pnlDadosProdutos.Height := 17;
    pnlDadosProdutos.Caption := 'Espa'#231'o form dados';
    pnlDadosProdutos.ChildOrder := 23;
    pnlDadosProdutos.Color := clInfoText;
    pnlDadosProdutos.Font.Charset := DEFAULT_CHARSET;
    pnlDadosProdutos.Font.Color := clWhite;
    pnlDadosProdutos.Font.Height := -11;
    pnlDadosProdutos.Font.Name := 'Tahoma';
    pnlDadosProdutos.Font.Style := [fsBold];
    pnlDadosProdutos.ParentFont := False;
    pnlDadosProdutos.TabOrder := 39;
    pnlDadosProdutos.Visible := False;
    btnDadosTab.SetParentComponent(Self);
    btnDadosTab.Name := 'btnDadosTab';
    btnDadosTab.Left := 792;
    btnDadosTab.Top := 20;
    btnDadosTab.Width := 96;
    btnDadosTab.Height := 25;
    btnDadosTab.Caption := 'Dados';
    btnDadosTab.ChildOrder := 16;
    btnDadosTab.HeightPercent := 100.000000000000000000;
    btnDadosTab.WidthPercent := 100.000000000000000000;
    btnAssociacaoTab.SetParentComponent(Self);
    btnAssociacaoTab.Name := 'btnAssociacaoTab';
    btnAssociacaoTab.Left := 792;
    btnAssociacaoTab.Top := 288;
    btnAssociacaoTab.Width := 96;
    btnAssociacaoTab.Height := 25;
    btnAssociacaoTab.Caption := 'Associa'#231#227'o';
    btnAssociacaoTab.ChildOrder := 16;
    btnAssociacaoTab.HeightPercent := 100.000000000000000000;
    btnAssociacaoTab.WidthPercent := 100.000000000000000000;
    ed_ncm_ncm.SetParentComponent(Self);
    ed_ncm_ncm.Name := 'ed_ncm_ncm';
    ed_ncm_ncm.Left := 650;
    ed_ncm_ncm.Top := 344;
    ed_ncm_ncm.Width := 120;
    ed_ncm_ncm.Height := 21;
    ed_ncm_ncm.ChildOrder := 82;
    ed_ncm_ncm.Enabled := False;
    ed_ncm_ncm.HeightPercent := 100.000000000000000000;
    ed_ncm_ncm.TabOrder := 13;
    ed_ncm_ncm.WidthPercent := 100.000000000000000000;
    ed_ncm_ncm.DataField := 'ncm.ncm';
    ed_ncm_ncm.DataSource := DataSource;
    pnlProdutoAssociado.SetParentComponent(Self);
    pnlProdutoAssociado.Name := 'pnlProdutoAssociado';
    pnlProdutoAssociado.Left := 8;
    pnlProdutoAssociado.Top := 395;
    pnlProdutoAssociado.Width := 360;
    pnlProdutoAssociado.Height := 17;
    pnlProdutoAssociado.Caption := 'Espa'#231'o form associa'#231#227'o';
    pnlProdutoAssociado.ChildOrder := 23;
    pnlProdutoAssociado.Color := clInfoText;
    pnlProdutoAssociado.Font.Charset := DEFAULT_CHARSET;
    pnlProdutoAssociado.Font.Color := clWhite;
    pnlProdutoAssociado.Font.Height := -11;
    pnlProdutoAssociado.Font.Name := 'Tahoma';
    pnlProdutoAssociado.Font.Style := [fsBold];
    pnlProdutoAssociado.ParentFont := False;
    pnlProdutoAssociado.TabOrder := 43;
    pnlProdutoAssociado.Visible := False;
    edtCodigoProdutoAssociado.SetParentComponent(Self);
    edtCodigoProdutoAssociado.Name := 'edtCodigoProdutoAssociado';
    edtCodigoProdutoAssociado.Left := 117;
    edtCodigoProdutoAssociado.Top := 422;
    edtCodigoProdutoAssociado.Width := 121;
    edtCodigoProdutoAssociado.Height := 22;
    edtCodigoProdutoAssociado.ChildOrder := 89;
    edtCodigoProdutoAssociado.Enabled := False;
    edtCodigoProdutoAssociado.HeightPercent := 100.000000000000000000;
    edtCodigoProdutoAssociado.WidthPercent := 100.000000000000000000;
    edtNomeProdutoAssociado.SetParentComponent(Self);
    edtNomeProdutoAssociado.Name := 'edtNomeProdutoAssociado';
    edtNomeProdutoAssociado.Left := 117;
    edtNomeProdutoAssociado.Top := 449;
    edtNomeProdutoAssociado.Width := 121;
    edtNomeProdutoAssociado.Height := 22;
    edtNomeProdutoAssociado.ChildOrder := 89;
    edtNomeProdutoAssociado.Enabled := False;
    edtNomeProdutoAssociado.HeightPercent := 100.000000000000000000;
    edtNomeProdutoAssociado.WidthPercent := 100.000000000000000000;
    edtCodBarrasProdutoAssociado.SetParentComponent(Self);
    edtCodBarrasProdutoAssociado.Name := 'edtCodBarrasProdutoAssociado';
    edtCodBarrasProdutoAssociado.Left := 117;
    edtCodBarrasProdutoAssociado.Top := 475;
    edtCodBarrasProdutoAssociado.Width := 121;
    edtCodBarrasProdutoAssociado.Height := 22;
    edtCodBarrasProdutoAssociado.ChildOrder := 89;
    edtCodBarrasProdutoAssociado.Enabled := False;
    edtCodBarrasProdutoAssociado.HeightPercent := 100.000000000000000000;
    edtCodBarrasProdutoAssociado.WidthPercent := 100.000000000000000000;
    edtStatusProdutoAssociado.SetParentComponent(Self);
    edtStatusProdutoAssociado.Name := 'edtStatusProdutoAssociado';
    edtStatusProdutoAssociado.Left := 117;
    edtStatusProdutoAssociado.Top := 503;
    edtStatusProdutoAssociado.Width := 121;
    edtStatusProdutoAssociado.Height := 22;
    edtStatusProdutoAssociado.ChildOrder := 89;
    edtStatusProdutoAssociado.Enabled := False;
    edtStatusProdutoAssociado.HeightPercent := 100.000000000000000000;
    edtStatusProdutoAssociado.WidthPercent := 100.000000000000000000;
    edpreco_consignado.SetParentComponent(Self);
    edpreco_consignado.Name := 'edpreco_consignado';
    edpreco_consignado.Left := 117;
    edpreco_consignado.Top := 373;
    edpreco_consignado.Width := 120;
    edpreco_consignado.Height := 21;
    edpreco_consignado.ChildOrder := 93;
    edpreco_consignado.Enabled := False;
    edpreco_consignado.HeightPercent := 100.000000000000000000;
    edpreco_consignado.TabOrder := 19;
    edpreco_consignado.Text := 'edpreco_consignado';
    edpreco_consignado.WidthPercent := 100.000000000000000000;
    edpreco_consignado.DataField := 'preco_consignado';
    edpreco_consignado.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := ProdutosDataset;
    DataSource.Left := 832;
    DataSource.Top := 218;
    ProdutosDataset.SetParentComponent(Self);
    ProdutosDataset.Name := 'ProdutosDataset';
    ProdutosDataset.AfterApplyUpdates := ProdutosDatasetAfterApplyUpdates;
    ProdutosDataset.AfterOpen := ProdutosDatasetAfterOpen;
    ProdutosDataset.EntitySetName := 'Produtos';
    ProdutosDataset.Connection := DMConnection.ApiConnection;
    ProdutosDataset.Left := 832;
    ProdutosDataset.Top := 154;
    ProdutosDatasetid.SetParentComponent(ProdutosDataset);
    ProdutosDatasetid.Name := 'ProdutosDatasetid';
    ProdutosDatasetid.FieldName := 'id';
    ProdutosDatasetid.Required := True;
    ProdutosDatasetaliado_id.SetParentComponent(ProdutosDataset);
    ProdutosDatasetaliado_id.Name := 'ProdutosDatasetaliado_id';
    ProdutosDatasetaliado_id.FieldName := 'aliado_id';
    ProdutosDatasetaliado_id.Required := True;
    ProdutosDatasetdata_base_id.SetParentComponent(ProdutosDataset);
    ProdutosDatasetdata_base_id.Name := 'ProdutosDatasetdata_base_id';
    ProdutosDatasetdata_base_id.FieldName := 'data_base_id';
    ProdutosDatasetdata_base_id.Required := True;
    ProdutosDatasetnome.SetParentComponent(ProdutosDataset);
    ProdutosDatasetnome.Name := 'ProdutosDatasetnome';
    ProdutosDatasetnome.FieldName := 'nome';
    ProdutosDatasetnome.Required := True;
    ProdutosDatasetnome.Size := 255;
    ProdutosDatasetnome_abreviado.SetParentComponent(ProdutosDataset);
    ProdutosDatasetnome_abreviado.Name := 'ProdutosDatasetnome_abreviado';
    ProdutosDatasetnome_abreviado.FieldName := 'nome_abreviado';
    ProdutosDatasetnome_abreviado.Required := True;
    ProdutosDatasetnome_abreviado.Size := 255;
    ProdutosDatasetcodigo_barras.SetParentComponent(ProdutosDataset);
    ProdutosDatasetcodigo_barras.Name := 'ProdutosDatasetcodigo_barras';
    ProdutosDatasetcodigo_barras.FieldName := 'codigo_barras';
    ProdutosDatasetcodigo_barras.Size := 255;
    ProdutosDatasetcodigo_fabrica.SetParentComponent(ProdutosDataset);
    ProdutosDatasetcodigo_fabrica.Name := 'ProdutosDatasetcodigo_fabrica';
    ProdutosDatasetcodigo_fabrica.FieldName := 'codigo_fabrica';
    ProdutosDatasetcodigo_fabrica.Size := 255;
    ProdutosDatasetestoque.SetParentComponent(ProdutosDataset);
    ProdutosDatasetestoque.Name := 'ProdutosDatasetestoque';
    ProdutosDatasetestoque.FieldName := 'estoque';
    ProdutosDatasetestoque.DisplayFormat := '0.000';
    ProdutosDatasetestoque_retido.SetParentComponent(ProdutosDataset);
    ProdutosDatasetestoque_retido.Name := 'ProdutosDatasetestoque_retido';
    ProdutosDatasetestoque_retido.FieldName := 'estoque_retido';
    ProdutosDatasetestoque_retido.Required := True;
    ProdutosDatasetestoque_retido.DisplayFormat := '0.000';
    ProdutosDatasetestoque_maximo.SetParentComponent(ProdutosDataset);
    ProdutosDatasetestoque_maximo.Name := 'ProdutosDatasetestoque_maximo';
    ProdutosDatasetestoque_maximo.FieldName := 'estoque_maximo';
    ProdutosDatasetestoque_maximo.DisplayFormat := '0.000';
    ProdutosDatasetestoque_minimo.SetParentComponent(ProdutosDataset);
    ProdutosDatasetestoque_minimo.Name := 'ProdutosDatasetestoque_minimo';
    ProdutosDatasetestoque_minimo.FieldName := 'estoque_minimo';
    ProdutosDatasetestoque_minimo.DisplayFormat := '0.000';
    ProdutosDatasetpreco_custo.SetParentComponent(ProdutosDataset);
    ProdutosDatasetpreco_custo.Name := 'ProdutosDatasetpreco_custo';
    ProdutosDatasetpreco_custo.FieldName := 'preco_custo';
    ProdutosDatasetpreco_custo.Required := True;
    ProdutosDatasetpreco_custo.DisplayFormat := '0.000';
    ProdutosDatasetpreco_venda.SetParentComponent(ProdutosDataset);
    ProdutosDatasetpreco_venda.Name := 'ProdutosDatasetpreco_venda';
    ProdutosDatasetpreco_venda.FieldName := 'preco_venda';
    ProdutosDatasetpreco_venda.Required := True;
    ProdutosDatasetpreco_venda.DisplayFormat := '0.000';
    ProdutosDatasetpreco_promocional.SetParentComponent(ProdutosDataset);
    ProdutosDatasetpreco_promocional.Name := 'ProdutosDatasetpreco_promocional';
    ProdutosDatasetpreco_promocional.FieldName := 'preco_promocional';
    ProdutosDatasetpreco_promocional.DisplayFormat := '0.000';
    ProdutosDatasetmargem_lucro.SetParentComponent(ProdutosDataset);
    ProdutosDatasetmargem_lucro.Name := 'ProdutosDatasetmargem_lucro';
    ProdutosDatasetmargem_lucro.FieldName := 'margem_lucro';
    ProdutosDatasetmargem_lucro.DisplayFormat := '0.00000';
    ProdutosDatasetpreco_padrao.SetParentComponent(ProdutosDataset);
    ProdutosDatasetpreco_padrao.Name := 'ProdutosDatasetpreco_padrao';
    ProdutosDatasetpreco_padrao.FieldName := 'preco_padrao';
    ProdutosDatasetpreco_padrao.Required := True;
    SetEvent(ProdutosDatasetpreco_padrao, Self, 'OnGetText', 'ProdutosDatasetpreco_padraoGetText');
    ProdutosDatasetdesconto_maximo.SetParentComponent(ProdutosDataset);
    ProdutosDatasetdesconto_maximo.Name := 'ProdutosDatasetdesconto_maximo';
    ProdutosDatasetdesconto_maximo.FieldName := 'desconto_maximo';
    ProdutosDatasetdesconto_maximo.DisplayFormat := '0.00000';
    ProdutosDatasetvalor_desconto_maximo.SetParentComponent(ProdutosDataset);
    ProdutosDatasetvalor_desconto_maximo.Name := 'ProdutosDatasetvalor_desconto_maximo';
    ProdutosDatasetvalor_desconto_maximo.FieldName := 'valor_desconto_maximo';
    ProdutosDatasetvalor_desconto_maximo.DisplayFormat := '0.00';
    ProdutosDatasetcomissao.SetParentComponent(ProdutosDataset);
    ProdutosDatasetcomissao.Name := 'ProdutosDatasetcomissao';
    ProdutosDatasetcomissao.FieldName := 'comissao';
    ProdutosDatasetcomissao.DisplayFormat := '0.00000';
    ProdutosDatasetstatus.SetParentComponent(ProdutosDataset);
    ProdutosDatasetstatus.Name := 'ProdutosDatasetstatus';
    ProdutosDatasetstatus.FieldName := 'status';
    ProdutosDatasetstatus.Required := True;
    SetEvent(ProdutosDatasetstatus, Self, 'OnGetText', 'ProdutosDatasetstatusGetText');
    ProdutosDatasetunidade_id.SetParentComponent(ProdutosDataset);
    ProdutosDatasetunidade_id.Name := 'ProdutosDatasetunidade_id';
    ProdutosDatasetunidade_id.FieldName := 'unidade_id';
    ProdutosDatasetunidade_id.Required := True;
    ProdutosDatasetsubgrupo_id.SetParentComponent(ProdutosDataset);
    ProdutosDatasetsubgrupo_id.Name := 'ProdutosDatasetsubgrupo_id';
    ProdutosDatasetsubgrupo_id.FieldName := 'subgrupo_id';
    ProdutosDatasetsubgrupo_id.Required := True;
    ProdutosDatasetdesativado.SetParentComponent(ProdutosDataset);
    ProdutosDatasetdesativado.Name := 'ProdutosDatasetdesativado';
    ProdutosDatasetdesativado.FieldName := 'desativado';
    ProdutosDatasetdesativado.Required := True;
    ProdutosDatasetgerencial.SetParentComponent(ProdutosDataset);
    ProdutosDatasetgerencial.Name := 'ProdutosDatasetgerencial';
    ProdutosDatasetgerencial.FieldName := 'gerencial';
    ProdutosDatasetgerencial.Required := True;
    ProdutosDatasetcomposto.SetParentComponent(ProdutosDataset);
    ProdutosDatasetcomposto.Name := 'ProdutosDatasetcomposto';
    ProdutosDatasetcomposto.FieldName := 'composto';
    ProdutosDatasetcomposto.Required := True;
    ProdutosDatasetgrade.SetParentComponent(ProdutosDataset);
    ProdutosDatasetgrade.Name := 'ProdutosDatasetgrade';
    ProdutosDatasetgrade.FieldName := 'grade';
    ProdutosDatasetgrade.Required := True;
    ProdutosDatasetcadastro.SetParentComponent(ProdutosDataset);
    ProdutosDatasetcadastro.Name := 'ProdutosDatasetcadastro';
    ProdutosDatasetcadastro.FieldName := 'cadastro';
    ProdutosDatasetcadastro.DisplayFormat := 'dd/mm/yyyy';
    ProdutosDatasetpeso_bruto.SetParentComponent(ProdutosDataset);
    ProdutosDatasetpeso_bruto.Name := 'ProdutosDatasetpeso_bruto';
    ProdutosDatasetpeso_bruto.FieldName := 'peso_bruto';
    ProdutosDatasetpeso_bruto.DisplayFormat := '0.000';
    ProdutosDatasetpeso_liquido.SetParentComponent(ProdutosDataset);
    ProdutosDatasetpeso_liquido.Name := 'ProdutosDatasetpeso_liquido';
    ProdutosDatasetpeso_liquido.FieldName := 'peso_liquido';
    ProdutosDatasetpeso_liquido.DisplayFormat := '0.000';
    ProdutosDatasetproduto_movimenta_estoque.SetParentComponent(ProdutosDataset);
    ProdutosDatasetproduto_movimenta_estoque.Name := 'ProdutosDatasetproduto_movimenta_estoque';
    ProdutosDatasetproduto_movimenta_estoque.FieldName := 'produto_movimenta_estoque';
    ProdutosDatasetproduto_movimenta_estoque_quantidade.SetParentComponent(ProdutosDataset);
    ProdutosDatasetproduto_movimenta_estoque_quantidade.Name := 'ProdutosDatasetproduto_movimenta_estoque_quantidade';
    ProdutosDatasetproduto_movimenta_estoque_quantidade.FieldName := 'produto_movimenta_estoque_quantidade';
    ProdutosDatasetproduto_movimenta_estoque_quantidade.DisplayFormat := '0.000';
    ProdutosDatasetaplicacao.SetParentComponent(ProdutosDataset);
    ProdutosDatasetaplicacao.Name := 'ProdutosDatasetaplicacao';
    ProdutosDatasetaplicacao.FieldName := 'aplicacao';
    ProdutosDatasetaplicacao.Size := 255;
    ProdutosDatasetobservacoes.SetParentComponent(ProdutosDataset);
    ProdutosDatasetobservacoes.Name := 'ProdutosDatasetobservacoes';
    ProdutosDatasetobservacoes.FieldName := 'observacoes';
    ProdutosDatasetobservacoes.Size := 255;
    ProdutosDatasettributacao.SetParentComponent(ProdutosDataset);
    ProdutosDatasettributacao.Name := 'ProdutosDatasettributacao';
    ProdutosDatasettributacao.FieldName := 'tributacao';
    ProdutosDatasettributacao.Required := True;
    ProdutosDatasettributacao.Size := 255;
    ProdutosDatasetcodigo_interno.SetParentComponent(ProdutosDataset);
    ProdutosDatasetcodigo_interno.Name := 'ProdutosDatasetcodigo_interno';
    ProdutosDatasetcodigo_interno.FieldName := 'codigo_interno';
    ProdutosDatasetcodigo_interno.Required := True;
    ProdutosDatasetexcluido.SetParentComponent(ProdutosDataset);
    ProdutosDatasetexcluido.Name := 'ProdutosDatasetexcluido';
    ProdutosDatasetexcluido.FieldName := 'excluido';
    ProdutosDatasetinclusao.SetParentComponent(ProdutosDataset);
    ProdutosDatasetinclusao.Name := 'ProdutosDatasetinclusao';
    ProdutosDatasetinclusao.FieldName := 'inclusao';
    ProdutosDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    ProdutosDatasetalteracao.SetParentComponent(ProdutosDataset);
    ProdutosDatasetalteracao.Name := 'ProdutosDatasetalteracao';
    ProdutosDatasetalteracao.FieldName := 'alteracao';
    ProdutosDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    ProdutosDatasetexclusao.SetParentComponent(ProdutosDataset);
    ProdutosDatasetexclusao.Name := 'ProdutosDatasetexclusao';
    ProdutosDatasetexclusao.FieldName := 'exclusao';
    ProdutosDatasetexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    ProdutosDatasetunidadesigla.SetParentComponent(ProdutosDataset);
    ProdutosDatasetunidadesigla.Name := 'ProdutosDatasetunidadesigla';
    ProdutosDatasetunidadesigla.FieldName := 'unidade.sigla';
    ProdutosDatasetsubgruponome.SetParentComponent(ProdutosDataset);
    ProdutosDatasetsubgruponome.Name := 'ProdutosDatasetsubgruponome';
    ProdutosDatasetsubgruponome.FieldName := 'subgrupo.nome';
    ProdutosDatasetsubgrupogruponome.SetParentComponent(ProdutosDataset);
    ProdutosDatasetsubgrupogruponome.Name := 'ProdutosDatasetsubgrupogruponome';
    ProdutosDatasetsubgrupogruponome.FieldName := 'subgrupo.grupo.nome';
    ProdutosDatasetaliadoNome_Fantasia.SetParentComponent(ProdutosDataset);
    ProdutosDatasetaliadoNome_Fantasia.Name := 'ProdutosDatasetaliadoNome_Fantasia';
    ProdutosDatasetaliadoNome_Fantasia.FieldName := 'aliado.Nome_Fantasia';
    SetEvent(ProdutosDatasetaliadoNome_Fantasia, Self, 'OnGetText', 'ProdutosDatasetaliadoNome_FantasiaGetText');
    ProdutosDatasetassociacaofsprodimagem.SetParentComponent(ProdutosDataset);
    ProdutosDatasetassociacaofsprodimagem.Name := 'ProdutosDatasetassociacaofsprodimagem';
    ProdutosDatasetassociacaofsprodimagem.FieldName := 'associacao.fsprod.imagem';
    ProdutosDatasetassociacaofsprodid.SetParentComponent(ProdutosDataset);
    ProdutosDatasetassociacaofsprodid.Name := 'ProdutosDatasetassociacaofsprodid';
    ProdutosDatasetassociacaofsprodid.FieldName := 'associacao.fsprod.id';
    ProdutosDatasetassociacaofsprodnome.SetParentComponent(ProdutosDataset);
    ProdutosDatasetassociacaofsprodnome.Name := 'ProdutosDatasetassociacaofsprodnome';
    ProdutosDatasetassociacaofsprodnome.FieldName := 'associacao.fsprod.nome';
    ProdutosDatasetassociacaofsprodcodigo_barras.SetParentComponent(ProdutosDataset);
    ProdutosDatasetassociacaofsprodcodigo_barras.Name := 'ProdutosDatasetassociacaofsprodcodigo_barras';
    ProdutosDatasetassociacaofsprodcodigo_barras.FieldName := 'associacao.fsprod.codigo_barras';
    ProdutosDatasetassociacaostatus.SetParentComponent(ProdutosDataset);
    ProdutosDatasetassociacaostatus.Name := 'ProdutosDatasetassociacaostatus';
    ProdutosDatasetassociacaostatus.FieldKind := fkCalculated;
    ProdutosDatasetassociacaostatus.FieldName := 'associacao.status';
    ProdutosDatasetassociacaostatus.Calculated := True;
    ProdutosDatasetassociacaoimagem_aprovacao.SetParentComponent(ProdutosDataset);
    ProdutosDatasetassociacaoimagem_aprovacao.Name := 'ProdutosDatasetassociacaoimagem_aprovacao';
    ProdutosDatasetassociacaoimagem_aprovacao.FieldName := 'associacao.imagem_aprovacao';
    ProdutosDatasetncmncm.SetParentComponent(ProdutosDataset);
    ProdutosDatasetncmncm.Name := 'ProdutosDatasetncmncm';
    ProdutosDatasetncmncm.FieldName := 'ncm.ncm';
    ProdutosDatasetpreco_consignado.SetParentComponent(ProdutosDataset);
    ProdutosDatasetpreco_consignado.Name := 'ProdutosDatasetpreco_consignado';
    ProdutosDatasetpreco_consignado.FieldName := 'preco_consignado';
    ProdutosDatasetpreco_consignado.DisplayFormat := '0.000';
    XDataClientProdutosGet.SetParentComponent(Self);
    XDataClientProdutosGet.Name := 'XDataClientProdutosGet';
    XDataClientProdutosGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientProdutosGet, Self, 'OnLoad', 'XDataClientProdutosGetLoad');
    XDataClientProdutosGet.Left := 832;
    XDataClientProdutosGet.Top := 90;
  finally
    lbid.AfterLoadDFMValues;
    lbaliado_nome.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    lbnome_abreviado.AfterLoadDFMValues;
    lbcodigo_barras.AfterLoadDFMValues;
    lbcodigo_fabrica.AfterLoadDFMValues;
    lbestoque.AfterLoadDFMValues;
    lbestoque_retido.AfterLoadDFMValues;
    lbestoque_maximo.AfterLoadDFMValues;
    lbestoque_minimo.AfterLoadDFMValues;
    lbpreco_custo.AfterLoadDFMValues;
    lbpreco_venda.AfterLoadDFMValues;
    lbpreco_promocional.AfterLoadDFMValues;
    lbmargem_lucro.AfterLoadDFMValues;
    lbpreco_padrao.AfterLoadDFMValues;
    lbdesconto_maximo.AfterLoadDFMValues;
    lbvalor_desconto_maximo.AfterLoadDFMValues;
    lbcomissao.AfterLoadDFMValues;
    lbstatus.AfterLoadDFMValues;
    lbunidade_nome.AfterLoadDFMValues;
    lbsubgrupo_nome.AfterLoadDFMValues;
    lbdesativado.AfterLoadDFMValues;
    lbgerencial.AfterLoadDFMValues;
    lbcomposto.AfterLoadDFMValues;
    lbgrade.AfterLoadDFMValues;
    lbcadastro.AfterLoadDFMValues;
    lbpeso_bruto.AfterLoadDFMValues;
    lbpeso_liquido.AfterLoadDFMValues;
    lbproduto_movimenta_estoque.AfterLoadDFMValues;
    lbproduto_movimenta_estoque_quantidade.AfterLoadDFMValues;
    lbaplicacao.AfterLoadDFMValues;
    lbobservacoes.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    lbgrupo_nome.AfterLoadDFMValues;
    lbncm_ncm.AfterLoadDFMValues;
    lblCodigoProdutoAssociado.AfterLoadDFMValues;
    lblNomeProdutoAssociado.AfterLoadDFMValues;
    lblCodBarrasProdutoAssociado.AfterLoadDFMValues;
    lblStatusProdutoAssociado.AfterLoadDFMValues;
    imgProduto.AfterLoadDFMValues;
    lbpreco_consignado.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    edaliado_nome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    ednome_abreviado.AfterLoadDFMValues;
    edcodigo_barras.AfterLoadDFMValues;
    edcodigo_fabrica.AfterLoadDFMValues;
    edestoque.AfterLoadDFMValues;
    edestoque_retido.AfterLoadDFMValues;
    edestoque_maximo.AfterLoadDFMValues;
    edestoque_minimo.AfterLoadDFMValues;
    edpreco_custo.AfterLoadDFMValues;
    edpreco_venda.AfterLoadDFMValues;
    edpreco_promocional.AfterLoadDFMValues;
    edmargem_lucro.AfterLoadDFMValues;
    edpreco_padrao.AfterLoadDFMValues;
    eddesconto_maximo.AfterLoadDFMValues;
    edvalor_desconto_maximo.AfterLoadDFMValues;
    edcomissao.AfterLoadDFMValues;
    edstatus.AfterLoadDFMValues;
    edunidade_nome.AfterLoadDFMValues;
    edsubgrupo_nome.AfterLoadDFMValues;
    edcadastro.AfterLoadDFMValues;
    edpeso_bruto.AfterLoadDFMValues;
    edpeso_liquido.AfterLoadDFMValues;
    edproduto_movimenta_estoque.AfterLoadDFMValues;
    edproduto_movimenta_estoque_quantidade.AfterLoadDFMValues;
    edaplicacao.AfterLoadDFMValues;
    edobservacoes.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    edgrupo_nome.AfterLoadDFMValues;
    cbxdesativado.AfterLoadDFMValues;
    cbxgerencial.AfterLoadDFMValues;
    cbxcomposto.AfterLoadDFMValues;
    cbxgrade.AfterLoadDFMValues;
    cbxexcluido.AfterLoadDFMValues;
    pnlDadosProdutos.AfterLoadDFMValues;
    btnDadosTab.AfterLoadDFMValues;
    btnAssociacaoTab.AfterLoadDFMValues;
    ed_ncm_ncm.AfterLoadDFMValues;
    pnlProdutoAssociado.AfterLoadDFMValues;
    edtCodigoProdutoAssociado.AfterLoadDFMValues;
    edtNomeProdutoAssociado.AfterLoadDFMValues;
    edtCodBarrasProdutoAssociado.AfterLoadDFMValues;
    edtStatusProdutoAssociado.AfterLoadDFMValues;
    edpreco_consignado.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    ProdutosDataset.AfterLoadDFMValues;
    ProdutosDatasetid.AfterLoadDFMValues;
    ProdutosDatasetaliado_id.AfterLoadDFMValues;
    ProdutosDatasetdata_base_id.AfterLoadDFMValues;
    ProdutosDatasetnome.AfterLoadDFMValues;
    ProdutosDatasetnome_abreviado.AfterLoadDFMValues;
    ProdutosDatasetcodigo_barras.AfterLoadDFMValues;
    ProdutosDatasetcodigo_fabrica.AfterLoadDFMValues;
    ProdutosDatasetestoque.AfterLoadDFMValues;
    ProdutosDatasetestoque_retido.AfterLoadDFMValues;
    ProdutosDatasetestoque_maximo.AfterLoadDFMValues;
    ProdutosDatasetestoque_minimo.AfterLoadDFMValues;
    ProdutosDatasetpreco_custo.AfterLoadDFMValues;
    ProdutosDatasetpreco_venda.AfterLoadDFMValues;
    ProdutosDatasetpreco_promocional.AfterLoadDFMValues;
    ProdutosDatasetmargem_lucro.AfterLoadDFMValues;
    ProdutosDatasetpreco_padrao.AfterLoadDFMValues;
    ProdutosDatasetdesconto_maximo.AfterLoadDFMValues;
    ProdutosDatasetvalor_desconto_maximo.AfterLoadDFMValues;
    ProdutosDatasetcomissao.AfterLoadDFMValues;
    ProdutosDatasetstatus.AfterLoadDFMValues;
    ProdutosDatasetunidade_id.AfterLoadDFMValues;
    ProdutosDatasetsubgrupo_id.AfterLoadDFMValues;
    ProdutosDatasetdesativado.AfterLoadDFMValues;
    ProdutosDatasetgerencial.AfterLoadDFMValues;
    ProdutosDatasetcomposto.AfterLoadDFMValues;
    ProdutosDatasetgrade.AfterLoadDFMValues;
    ProdutosDatasetcadastro.AfterLoadDFMValues;
    ProdutosDatasetpeso_bruto.AfterLoadDFMValues;
    ProdutosDatasetpeso_liquido.AfterLoadDFMValues;
    ProdutosDatasetproduto_movimenta_estoque.AfterLoadDFMValues;
    ProdutosDatasetproduto_movimenta_estoque_quantidade.AfterLoadDFMValues;
    ProdutosDatasetaplicacao.AfterLoadDFMValues;
    ProdutosDatasetobservacoes.AfterLoadDFMValues;
    ProdutosDatasettributacao.AfterLoadDFMValues;
    ProdutosDatasetcodigo_interno.AfterLoadDFMValues;
    ProdutosDatasetexcluido.AfterLoadDFMValues;
    ProdutosDatasetinclusao.AfterLoadDFMValues;
    ProdutosDatasetalteracao.AfterLoadDFMValues;
    ProdutosDatasetexclusao.AfterLoadDFMValues;
    ProdutosDatasetunidadesigla.AfterLoadDFMValues;
    ProdutosDatasetsubgruponome.AfterLoadDFMValues;
    ProdutosDatasetsubgrupogruponome.AfterLoadDFMValues;
    ProdutosDatasetaliadoNome_Fantasia.AfterLoadDFMValues;
    ProdutosDatasetassociacaofsprodimagem.AfterLoadDFMValues;
    ProdutosDatasetassociacaofsprodid.AfterLoadDFMValues;
    ProdutosDatasetassociacaofsprodnome.AfterLoadDFMValues;
    ProdutosDatasetassociacaofsprodcodigo_barras.AfterLoadDFMValues;
    ProdutosDatasetassociacaostatus.AfterLoadDFMValues;
    ProdutosDatasetassociacaoimagem_aprovacao.AfterLoadDFMValues;
    ProdutosDatasetncmncm.AfterLoadDFMValues;
    ProdutosDatasetpreco_consignado.AfterLoadDFMValues;
    XDataClientProdutosGet.AfterLoadDFMValues;
  end;
end;

end.

